<mat-card class="slidecontent">


  <form [formGroup]="myTaskForm">
    <div class="docheader">

      <div class="marked">

        <div class="txt">
          {{taskDetailList.title}}
        </div>
        <button mat-icon-button [matMenuTriggerFor]="taskSubActions">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <div class="action">
        <div class="taskAction">        

        <mat-form-field appearance="fill">
          <mat-label>Task Status</mat-label>
          <mat-select (selectionChange)="getStatusVal($event)" formControlName="taskStatus">
            <mat-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                {{ stat.taskStatusName }}
            </mat-option>
        </mat-select>
          
        </mat-form-field>     

        <mat-form-field appearance="fill">
          <mat-label>Priority</mat-label>
          <mat-select (selectionChange)="getPreorityVal($event)" formControlName="preorityID">
            <mat-option  value="1">Lowest</mat-option>
            <mat-option  value="2">Low</mat-option>
            <mat-option  value="3">Medium</mat-option>
            <mat-option  value="4">High</mat-option>
            <mat-option  value="5">Highest</mat-option>
        </mat-select>
          
        </mat-form-field>

        </div>

        <button mat-stroked-button color="primary" (click)="addFolder(addFolderDialog)">
          Add/Edit Trigger
        </button>
      </div>


      <mat-menu #taskSubActions="matMenu" xPosition="before">
        <button mat-menu-item (click)="addTaskOption('Assigned')">
          Assign Task
        </button>
        <button mat-menu-item (click)="addTaskOption('Reminder')">
          Add Reminder
        </button>
        <button mat-menu-item (click)="addTaskOption('Schedule')">
          Schedule By
        </button>
        <button mat-menu-item (click)="addTaskOption('Attach')">
          Attach Placeholder
        </button>
        <button mat-menu-item (click)="deleteTask()">
          Delete Task
        </button>
        <button mat-menu-item (click)="closedetail(close)">
          Close
        </button>

      </mat-menu>

    </div>
    <div class="detailtabs userdetails">

      <mat-tab-group (selectedTabChange)="settab($event)" mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Task Info">
          <div class="detail">

     
             
         

            <ng-container>
              <div class="createTask reminder">
                <div class="block colorExternal">
                  <div class="selectTaskColor">
                    <div class="selectedColor" (click)="toggleColorSelection()">
                      <span [ngStyle]="{ 'background-color': selectedColor }"></span>
                      <mat-icon>arrow_drop_down</mat-icon>
                    </div>
                    <div class="colGroup" *ngIf="showColorPannel">
                      <ng-container *ngFor="let color of colors; let i; as: index">
                        <label class="colm" [ngStyle]="{ 'background-color': color.colname }">
                          <input type="radio" id="{{ i }}" type="radio" value="{{ color.colname }}"
                            (click)="SelectColor(color.colname)" name="noteColor" />
                          <span class="checkmark"></span>
                        </label>
                      </ng-container>
                    </div>
                  </div>

              
                  <div class="extrnalTask">
                    <mat-checkbox color="primary" formControlName="isInternal">External Task</mat-checkbox>
                    <mat-checkbox class="ml-5" color="primary" formControlName="isDueDateTrigger" (change)="DueOnCreationCheckbox($event)"> Due on creation</mat-checkbox>
                    <mat-checkbox class="ml-5" *ngIf="showFieldBased == true" color="primary" formControlName="isDueOnFieldBased" (change)="DueOnFieldBasedCheckbox($event)"> Field-Based Due Date</mat-checkbox>
                  </div>
                </div>

                <mat-form-field appearance="" style="margin-top:5px;" *ngIf="showFieldBasedDropdonw == true">                   
                  <mat-select placeholder="Select Field"  formControlName="repeatTaskFieldId" (selectionChange)="getDrpFields($event)">
                    <mat-option *ngFor="let stat of FieldBasedDateDropDown" [value]="stat.fieldID">
                      {{ stat.fieldName }}
                  </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="block ">
                  <mat-form-field class="taskTitle">
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" maxlength="100" placeholder="Task Name" />
                  </mat-form-field>
                </div>
    
           <div class="block block_division">
                
            <mat-form-field class="dateInput">
              <mat-label>Start date</mat-label>
              <input matInput  [matDatepicker]="picker4" formControlName="startDate" readonly>
              <!-- <mat-icon *ngIf="dateHasValue()" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate($event)">clear</mat-icon> -->
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
            
            <mat-form-field class="dateInput">
              <mat-label>Due date</mat-label>
              <input matInput  [matDatepicker]="picker" formControlName="dueDate" readonly>
              <mat-icon *ngIf="dateHasValue()" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate($event)">clear</mat-icon>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
           </div>

                <div class="block">
                  <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description" maxlength="500" cdkTextareaAutosize
                      cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2">
                    </textarea>
                  </mat-form-field>
    
                  <mat-checkbox color="primary" formControlName="isRequired">Required</mat-checkbox>
                  <br>

                  <div class="subtaskHolder">
                    <form [formGroup]="dynamicForm">
                      <div formArrayName="filters">
                        <div  *ngFor="let filter of filtersFormArray.controls; let i = index;">
    
                          <div class="rep" [formGroupName]="i">
    
                            <div class="start">
                              <mat-icon>subdirectory_arrow_right</mat-icon>
                            </div>
    
                            
                            <mat-form-field class="example-full-width">
                              <mat-label>Subtask</mat-label>
                              <input matInput (input)="getSubtaskTitle($event,i)" formControlName="taskTitle" placeholder="Add Subtask Name">
                            </mat-form-field>
    
                            <mat-form-field appearance="" style="width:150px; margin-right: 10px;">
                              <mat-label>Task Status</mat-label>
                              <mat-select (selectionChange)="getSubtaskStaus($event,i)" placeholder="Task Status" formControlName="status">
                                <mat-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                                  {{ stat.taskStatusName }}
                              </mat-option>
                              </mat-select>
                            </mat-form-field>
    
                            <button mat-icon-button class="remove"
                              (click)="removeFilterFromFiltersFormArray(i,filter.value)">
                              <mat-icon>remove_circle_outline</mat-icon>
                            </button>
    
                          </div>
                        </div>
    
                        <button class="subtask" mat-stroked-button color="primary" (click)="addFilterToFiltersFormArray()">
                          <mat-icon>add</mat-icon>
                          Subtask
                        </button>
    
                      </div>
                    </form>
                  </div>
    
                </div>
    
    
              </div>
            </ng-container>


            <div class="reminder taskActionType createTask">
              <div class="remind">
                <div class="mlabel">
                  Action Type
                </div>
              </div>
    
              <mat-form-field appearance="fill">
                <mat-label>Action Type</mat-label>
                <mat-select (selectionChange)="getFormLink($event)" formControlName="selectedTaskActionType">
                  <mat-option value="1">Any</mat-option>
                  <mat-option value="2">Form</mat-option>
                  <mat-option value="3">Document</mat-option>             
                  <mat-option value="4">Video</mat-option>
                  <mat-option value="5">URL</mat-option>
                  <mat-option value="6">Email</mat-option>
                </mat-select>
              </mat-form-field>
    
              <!-- Action type form  -->
              <ng-container *ngIf="taskActionType == 2">

                

                <div class="block block_division">
                  
                  <div class="block block_division">
                    <mat-form-field class="taskTitle" *ngIf="currentFormLinkFormName !='' && currentFormLinkFormName !=undefined">
                      <mat-label>Form Name</mat-label>
                      <input matInput formControlName="formLinkFormName" readonly placeholder="Form Name" />
                    </mat-form-field>
  
                    <mat-form-field class="taskTitle">
                      <mat-label>Add form link</mat-label>
                      <input matInput formControlName="formLink" readonly placeholder="Add form link" />
                      <!-- <input matInput (blur)="setFormURL()" formControlName="formLink" placeholder="Add form link" /> -->
                    </mat-form-field>   
                  </div>
                
                  <button matTooltip="Select Form" mat-icon-button color="primary" (click)="OpenFormPopup()">
                    <mat-icon>add</mat-icon>
                  </button>
                  
                </div>
          
                <div class="actionsTypeButtons">
                  <button *ngIf="projectID == 0" [disabled]="disableFormLink==true"  mat-stroked-button color="primary" (click)="createProject()">Create </button>
                  <button *ngIf="projectID > 0"  mat-stroked-button color="primary" (click)="resetProject()">Edit & Reset </button>
                  <button *ngIf="projectID == 0" [disabled]="disableFormLink==true" mat-stroked-button color="primary" (click)="openFormURL()"> URL </button>
                  <button *ngIf="projectID > 0"  mat-stroked-button color="primary" (click)="viewProject()">View Project </button>
                  <button [disabled]="disableFormLink==true" mat-stroked-button color="primary" (click)="openSignNowURL()"> Sign Now </button>
                </div>

                <!-- <button mat-flat-button color="primary" (click)="openFormURL()"> Open URL </button> -->
              </ng-container>
              <ng-container *ngIf="taskActionType == 4">
                <div class="d-flex">
                  <mat-form-field class="taskTitle">
                    <mat-label>Add video link</mat-label>
                    <input matInput (blur)="setFormURL()" formControlName="formLink" placeholder="Add Video link" />
                  </mat-form-field>
                  <a mat-icon-button color="primary" matTooltip="Need help?" href="https://support.flowtrics.com/472948-Adding-Videos-to-Task-Lists" target="_blank" ><mat-icon>help</mat-icon></a>

                </div>
              

                <button mat-flat-button color="primary" (click)="openFormURL()"> Open URL </button>
              </ng-container>
              <ng-container *ngIf="taskActionType == 5">
                <mat-form-field class="taskTitle">
                  <mat-label>Add URL</mat-label>
                  <input matInput (blur)="setFormURL()" formControlName="formLink" placeholder="Add URL" />
                </mat-form-field>
    
                <button mat-flat-button color="primary" (click)="openFormURL()"> Open URL </button>
              </ng-container>
    
              <!-- Action type document -->
              <ng-container *ngIf="taskActionType == 3">
                <ng-container *ngFor="let document of allUploadedDocuments">
    
    
                  <span class="documentList">
                    <div class="userpic">
                      <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
                    </div>
                    <div class="info">
                      <a href="{{document.documentPath}}" target="_blank"> {{ document.documentName }}                   
                      </a>
                      
                     <div class="">
                       <button mat-icon-button matTooltipClass="tooltip" matTooltip="{{ document.externalUploadedBy ? document.externalUploadedBy : document.firstName + ' ' + document.lastName  }}" >
                        <mat-icon>upload</mat-icon>
                      </button>
                      <button mat-icon-button (click)="deleteDocument(document.taskAttachedEntityMappingID)">
                        <mat-icon>delete</mat-icon>
                      </button>
                     </div>
    
                    </div>
                  </span>
                </ng-container>
              </ng-container>
    
              <div class="selectedSchedule subtaskHolder NotiHolder" *ngIf="taskActionType == 6">

                <div *ngIf="disabledEmailNotification == true" style="color: red;">
                  To enable the Email Action feature, configure your custom SMTP settings in the Admin section. Navigate to the Organization tab, then select Mail to enter the required SMTP details.
                </div>
                <br>

                <label class="mlabel">Setup Email Actions</label>

                <mat-form-field class="example-full-width" *ngIf="showRepeatTaskEmail == true">                  
                  <input matInput  type="text" placeholder="Add Email" formControlName="emailTemplate"
                  (input)="onEmailTemplateChange($event.target.value)" >
                </mat-form-field>

                <form [formGroup]="dynamicFormNotificationEmail">
                  <div formArrayName="filtersmNotificationEmail">
                    <div  *ngFor="let filter of filtersFormArrayNotificationEmail.controls; let i = index;">

                      <div class="rep repNotification" [formGroupName]="i">                       
                      
                          <mat-form-field appearance="fill" class="days">
                            <mat-select placeholder="Select Email Template" formControlName="templateID" [disabled]="disabledEmailNotification==true">
                              <mat-option *ngFor="let stat of emailTemplateList" [value]="stat.emailTemplateID">
                                {{ stat.emailTemplateName }}
                            </mat-option>
                            </mat-select>
                          </mat-form-field>                       
                        
                        <mat-form-field appearance="fill" class="time">
                          <input type="number" matInput formControlName="number" placeholder="Period" 
                          (keypress)="numberOnly($event)" min="1" max="31" maxlength="2" [readonly]="disabledEmailNotification==true">
                        </mat-form-field>

                        <mat-form-field appearance="fill"  class="days">
                          <mat-select placeholder="Select Time Period" formControlName="period" [disabled]="disabledEmailNotification==true">
                            <mat-option *ngFor="let stat of notificationdays" [value]="stat.name">
                              {{ stat.name }}
                          </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <button mat-icon-button class="remove" [disabled]="disabledEmailNotification==true"
                          (click)="removeFilterFromFiltersFormArrayNotificationEmail(i,filter.value)">
                          <mat-icon>remove_circle_outline</mat-icon>
                        </button>

                      </div>
                    </div>
                 
                    <button class="subtask" mat-stroked-button color="primary" *ngIf="filtersFormArrayNotificationEmail.length != 5" 
                    (click)="addFilterToFiltersFormArrayNotificationEmail()" [disabled]="disabledEmailNotification==true">
                      <mat-icon>add</mat-icon>
                      Email Actions
                    </button>

                    <p class="upto5" *ngIf="filtersFormArrayNotificationEmail.length == 5">Only upto 5 Email Actions you can add.</p>

                  </div>
                </form>
              </div>
    
              <div class="upDoc" *ngIf="taskActionType == 3">
                <div class="uploadholder">
                  <input #Input type="file" multiple (change)="selectFilesFromDragZone($event)" />
                  <div class="textIn">
                    <p>Drag and drop files here </p>
                  </div>
                </div>
              </div>
    
            </div>
            

             <!-- Attach  3C-->
          
             <div class="reminder">
              <div class="remind">
                <div class="mlabel">Attach To</div>      
                <mat-slide-toggle color="primary" [checked]="isAttachEntity" (change)="getAttached3c($event)">
                </mat-slide-toggle> 
              </div>
  
              <ng-container *ngIf="isAttachEntity">           
                <div class="block mt-10">
                  <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCCC($event)">
                    <mat-radio-button value="Core" [checked]="checkedAttachCore">{{CoreShowName}}</mat-radio-button>
                    <mat-radio-button value="Contact" [checked]="checkedAttachContact">{{ContactShowName}}</mat-radio-button>
                    <mat-radio-button value="Company" [checked]="checkedAttachCompany">{{CompanyShowName}}</mat-radio-button>
                  </mat-radio-group>
                </div>
  
  
                <div class="block mt-10" *ngIf="ShowAttchedToCore">
                  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{CoreShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="attchedToCoreSelected(core)" *ngFor="let core of attachedToCoreList"
                        [value]="core.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                            <span class="username" *ngIf="core.imageUrl==''" class="username">
                              {{core.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ core.name }}</p>
                            <p class="email">{{ core.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
  
                  </mat-form-field>
                  <ul class="selectedlist" *ngFor="let core of attachedToSelectedCore">
                    <li *ngIf="!core.isDeleted">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="core.img!=''" src="{{core.img}}" alt="">
                          <span *ngIf="core.img==''" class="username">
                            {{core.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{core.name}}</h4>
                          <p>{{core.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="attchedToRemoveCore(core)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
  
                <div class="block mt-10" *ngIf="ShowAttchedToContact">
                  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{ContactShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="attchedToContactSelected(contact)"
                        *ngFor="let contact of attachedToContactList" [value]="contact.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                            <span class="username" *ngIf="contact.imageUrl==''" class="username">
                              {{contact.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ contact.name }}</p>
                            <p class="email">{{ contact.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
  
                  </mat-form-field>
                  <ul class="selectedlist" *ngFor="let contact of attachedToSelectedContact">
                    <li *ngIf="!contact.isDeleted">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
                          <span *ngIf="contact.img==''" class="username">
                            {{contact.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{contact.name}}</h4>
                          <p>{{contact.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="attchedToRemoveContact(contact)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
  
                <div class="block mt-10" *ngIf="ShowAttchedToCompany">
                  <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{CompanyShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchCompany($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="attchedToCompanySelected(company)"
                        *ngFor="let company of attachedToCompanyList" [value]="company.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="">
                            <span class="username" *ngIf="company.imageUrl==''" class="username">
                              {{company.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ company.name }}</p>
                            <p class="email">{{ company.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
  
                  </mat-form-field>
                  <ul class="selectedlist" *ngFor="let company of attachedToSelectedCompany">
                    <li *ngIf="!company.isDeleted">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="company.img!=''" src="{{company.img}}" alt="">
                          <span *ngIf="company.img==''" class="username">
                            {{company.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{company.name}}</h4>
                          <p>{{company.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="attchedToRemoveCompany(company)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <mat-form-field *ngIf="documentFolders.length>0 && (attachedToSelectedCore.length>0 || attachedToSelectedContact.length>0 || attachedToSelectedCompany.length>0)"  appearance="">
                  <mat-label>Document Folder</mat-label>
                  <mat-select formControlName="selectedFolderctrl" 
                    (selectionChange)="onfolderSelectionChanged($event)">
                    <mat-option *ngFor="let f of documentFolders" [value]="f.documentFolderID">{{f?.documentFolderName}}</mat-option>
                  </mat-select>
                </mat-form-field>
                  <span style="color:red" *ngIf="documentFolders.length==0 && (attachedToSelectedCore.length>0 || attachedToSelectedContact.length>0 || attachedToSelectedCompany.length>0)">Add a document folder to upload document.</span>
              </ng-container>
  
            </div>

            
            <ng-container>
              <div class="reminder">
                <div class="remind">
                  <div class="mlabel">Assigned To</div>
                  <mat-slide-toggle color="primary" [checked]="isAssignedEntity" (change)="getAssigned3c($event)">
                  </mat-slide-toggle> 
                </div>
                <ng-container *ngIf="isAssignedEntity">
                <div class="block mt-10">

                  <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCRE($event)">
                    <mat-radio-button  value="Role">Role</mat-radio-button>                     
                      <mat-radio-button value="User">User</mat-radio-button>
                      <mat-radio-button value="Contact">{{ ContactShowName}}</mat-radio-button>
                      <mat-radio-button value="Email">Email</mat-radio-button>
                  </mat-radio-group>

                  <!-- <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCRE($event)">
                  <mat-radio-button value="Role" [checked]="checkedRole">Role</mat-radio-button>
                    <mat-radio-button value="Relationship" [checked]="checkedRelationShip">Relationship</mat-radio-button>
                    <mat-radio-button value="User" [checked]="checkedUser">User</mat-radio-button>
                    <mat-radio-button value="Contact" [checked]="checkedContact">{{ ContactShowName}}</mat-radio-button>
                    <mat-radio-button value="Email" [checked]="checkedEmail">Email</mat-radio-button>
                  </mat-radio-group> -->
                </div>
    
                <div class="block mt-10" *ngIf="ShowContactBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search {{ ContactShowName}}</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchContact($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid"
                      (keydown.enter)="onEnter($event,'')">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (keydown.enter)="onEnter($event,contact)" (click)="contactSelected(contact)"
                        *ngFor="let contact of contactsList" [value]="contact.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                            <span class="username" *ngIf="contact.imageUrl==''" class="username">
                              {{contact.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ contact.name }}</p>
                            <p class="email">{{ contact.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>
                  <!-- <ul class="selectedlist">
                    <li *ngFor="let contact of selectedContacts">
                      <div class="userndetail">
                        <div class="userpic">
                          <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
                          <span *ngIf="contact.img==''" class="username">
                            {{contact.shortName}}
                          </span>
                        </div>
                        <div class="details">
                          <h4>{{contact.name}}</h4>
                          <p>{{contact.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="removeContact(contact)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul> -->
                </div>
    
                <div class="block mt-10" *ngIf="ShowRoleBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search role</mat-label>
                    <input matInput maxlength="50" placeholder="Search role" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchRoles($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="roleSelected(obj)" *ngFor="let obj of RoleList" [value]="obj.roleName">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="info">
                            <p> {{ obj.roleName }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>
                  <!-- <ul class="selectedlist">
                    <li *ngFor="let role of selectedRole">
                      <div class="userndetail">
                        <div class="details">
                          <h4> {{role.name}}</h4>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="removeRole(role)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul> -->
                </div>    
    
                <div class="block mt-10" *ngIf="ShowEmailBox">
                  <div class="relative">
                    <mat-form-field appearance="outline" >
                      <input matInput maxlength="100" class="form-control mtb-15" placeholder="Add email"
                        [(value)]="emailAssigned" (input)="emailCheck($event.target.value)" />
                    </mat-form-field>
      
                    <button color="primary" *ngIf="addEmailButtonShow" (click)="addEmail()" mat-icon-button>
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
    
                  <!-- <ul class="selectedlist">
                    <li *ngFor="let email of selectedEmail">
                      <div class="userndetail">
                        <div class="details">
                          <p>{{email.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="removeEmail(email)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul> -->
    
    
                </div>    
    
                <div class="block mt-10" *ngIf="ShowUserBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search user</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchUser($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="userSelected(user)" *ngFor="let user of userList" [value]="user.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="user.imageUrl!=''" src="{{user.imageUrl}}" alt="">
                            <span class="username" *ngIf="user.imageUrl==''" class="username">
                              {{user.shortName}}
                            </span>
                          </div>
                          <div class="info">
                            <p> {{ user.name }}</p>
                            <p class="email">{{ user.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>
                  <!-- <ul class="selectedlist">
                    <li *ngFor="let user of selectedUser">
                      <div class="userndetail">
                        <div class="details">
                          <h4>{{user.name}}</h4>
                          <p>{{user.email}}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="removeUser(user)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul> -->
                </div>

                <div class="block mt-10" *ngIf="ShowRelationshipBox">
                  <mat-form-field appearance="outline"  class="mt-10 mb-10" style="position: relative;">
                    <mat-label>Search Relationship</mat-label>
                    <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                      (input)="searchRelationShip($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option (click)="relationSelected(rls)" *ngFor="let rls of resultUIRelationship" [value]="rls.name">
                        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                            <img *ngIf="rls.imageUrl!=''" src="{{rls.imageUrl}}" alt="">                       
                          </div>
                          <div class="info">
                            <p><span class="role">{{ rls.rloeName }}</span> {{ rls.name }}</p>
                            <p class="email">{{ rls.email }}</p>
                          </div>
                        </span>
                      </mat-option>
                    </mat-autocomplete>
    
                  </mat-form-field>
                  <!-- <ul class="selectedlist">
                    <li *ngFor="let srs of selectedUIRelationship">
                      <div class="userndetail">
                        <div class="details">
                          <h4>{{srs.name}}</h4>
                          <p>{{srs.email}}</p>
                          <p class="email">{{ srs.rloeName }}</p>
                        </div>
                        <div class="opt">
                          <button mat-icon-button>
                            <mat-icon (click)="removeRs(srs)">cancel</mat-icon>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul> -->
                </div>

                <ul class="selectedlist">
                  <li *ngFor="let ass of selectedAssignedTo">
                    <div class="userndetail">
                      <div class="userpic">
                        <img *ngIf="ass.img!=''" src="{{ass.img}}" alt="">
                        <span *ngIf="ass.img==''" class="username">
                          {{ass.shortName}}
                        </span>
                      </div>
                      <div class="details">
                        <h4>{{ass.name}}</h4>
                        <p>{{ass.email}}</p>
                      </div>
                      <div class="opt">
                        <button mat-icon-button>
                          <mat-icon (click)="removeAssignedTo(ass)">cancel</mat-icon>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>

              </ng-container>
              </div>
            </ng-container>

            <div class="reminder " *ngIf="showAddGroupButton==true">
              <div class="selectedSchedule byanothertask tschedule" >                  
                <div class="remind">
                  <div class="mlabel">
                    Schedule By Another Task
                   
                  </div>
                  <button mat-stroked-button color="primary" (click)="clearTaskSchedule()">
                    Clear
                  </button>
                  
                </div>                 
                
               <p class="sublabel">When:</p>
                 
                <div class="createTask ">
                  <div class="block block_division">
                    <mat-form-field appearance=""  class="taskTitle " style="position: relative;">
                      <mat-label>Select Dependent Task</mat-label>
                      <input matInput maxlength="150" [(ngModel)]="taskListName" placeholder="Search Task" aria-label="State" [matAutocomplete]="auto"
                        (input)="searchTask($event.target.value)" [formControl]="scheduledTaskCtrl" id="scheduledTaskCtrlid">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option (click)="taskSelected(obj)" *ngFor="let obj of SelectDependantTaskListFilter" [value]="obj.taskListName">
                          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                            <div class="info">
                              <p> {{ obj.taskListName }}</p>
                            </div>
                          </span>
                        </mat-option>
                      </mat-autocomplete>
      
                    </mat-form-field>

                    <mat-form-field appearance="" class="dateInput ">
                      <mat-label>Trigger Status/Due</mat-label>
                       <mat-select formControlName="triggerstatus" (selectionChange)="getStatusValForSchedule($event)">
                         <mat-option *ngFor="let stat of taskStatusListForSchedule" [value]="stat.taskStatusID">
                             {{ stat.taskStatusName }}
                         </mat-option>
                     </mat-select>                      
                     </mat-form-field>  


                  </div>

                  <p class="sublabel">Then:</p>

                  <div class="block block_division" style="justify-content: flex-start;" >
                    
                    <div class="" style="margin-right: 30px;" >
                      <p class="p10">Trigger this task:</p>
                    </div>
                     

                     <mat-form-field appearance="" class="dateInput" >
                      <mat-label>Trigger</mat-label>
                      <mat-select formControlName="triggertask" (selectionChange)="Triggertask($event)">
                        <mat-option value="duedate">Due date</mat-option>
                        <mat-option value="intasklist">In Task List</mat-option>                   
                      </mat-select>                      
                      </mat-form-field>

                  </div>




                </div>
                



            
                <div class="specific" *ngIf="showSchTask == true">
                  <div class="fieldr">   
                    <mat-form-field appearance="">                 
                      <mat-label>Amount of time </mat-label>
                    <input matInput type="text" 
                      min="0" max="99" minlength="0" maxlength="2" placeholder="Time Number"
                    formControlName="timenumber" (keypress)="numberOnlyForSch($event)" 
                    (input)="onTimeNoChange($event.target.value)"/>
                    </mat-form-field>
                    </div>
                    
                    <div class="fieldr">
                    <mat-form-field appearance="">
                    <mat-label>Select Time Period </mat-label>
                    <mat-select formControlName="timeperiod" (selectionChange)="selectTimePeriod($event)">
                      <mat-option value="immediately">Immediately</mat-option>
                      <!-- <mat-option value="hours">Hours</mat-option> -->
                      <mat-option value="days">Days</mat-option>
                      <mat-option value="weeks">Weeks</mat-option>                        
                    </mat-select>                      
                    </mat-form-field>
                    </div>
                    
                    <div class="fieldr">
                    <mat-form-field appearance="">
                    <mat-label>Select After Before </mat-label>
                    <mat-select formControlName="afterbefore" (selectionChange)="selectAfterBefore($event)">
                      <mat-option value="none">None</mat-option>
                      <mat-option value="after">After</mat-option>
                      <mat-option value="before">Before</mat-option>                                        
                    </mat-select>                      
                    </mat-form-field>
                    </div>
                </div>          
 
           </div>
            </div>
        

            <div class="reminder tschedule" *ngIf="showAddGroupButton==false">
    
              <mat-expansion-panel 
  [expanded]="panelState"
  class="mat-elevation-z8 font-blue"
  fxFlex>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="mlabel">Schedule Repeating Task</div> 
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
   
      <div class="selectedSchedule byrecurring">
                <label>Repeat</label>
    
                <div class="specific">    
               
    
                  <div class="fieldr">
                    <mat-form-field>
                      <mat-label>Repeat every</mat-label>
                      <input matInput type="number" min="1" max="99" minlength="0" maxlength="2" 
                      formControlName="repeatEvery" (keypress)="numberOnlyForSch($event)"/>                      
                    </mat-form-field>
                  </div>
    
                  <div class="fieldr">
                    <mat-form-field>
                      <mat-label>Repeat</mat-label>
                      <mat-select formControlName="repeatType" (selectionChange)="selectRepeat($event)">                     
                        <mat-option value="week">week</mat-option>
                        <mat-option value="month">month</mat-option>
                        <mat-option value="year">year</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
    
                </div>
    
                <ng-container *ngIf="ShowWeeks == true">
                  <p class="occurs">Repeat On</p>
    
                  <div class="everyday">                                     

                    <label class="checkmark">
                      <input type="checkbox"  [checked]="Sundaychecked" (change)="SundayClicked($event)" >
                      <span class="">S</span>
                    </label>
                    <label class="checkmark">
                      <input type="checkbox" [checked]="Mondaychecked" (change)="MondayClicked($event)">
                      <span class="">M</span>
                    </label>
                    <label class="checkmark">
                      <input type="checkbox" [checked]="Tuesdaychecked" (change)="TuesdayClicked($event)">
                      <span class="">T</span>
                    </label>
                    <label class="checkmark">
                      <input type="checkbox" [checked]="Wednesdaychecked" (change)="WednesdayClicked($event)">
                      <span class="">W</span>
                    </label>
      
                    <label class="checkmark">
                      <input type="checkbox" [checked]="Thursdaychecked" (change)="ThursdayClicked($event)">
                      <span class="">T</span>
                    </label>
                    <label class="checkmark">
                      <input type="checkbox" [checked]="Fridaychecked" (change)="FridayClicked($event)">
                      <span class="">F</span>
                    </label>
                    <label class="checkmark">
                      <input type="checkbox" [checked]="Saturdaychecked" (change)="SaturdayClicked($event)">
                      <span class="">S</span>
                    </label>
      
                  </div>
                </ng-container>
                
    
                <ng-container *ngIf="ShowMonths == true">
                  <mat-form-field>      
                    <mat-label>Select day</mat-label>             
                    <mat-select formControlName="monthDay">
                      <mat-option value="1">1</mat-option>
                      <mat-option value="2">2</mat-option>
                      <mat-option value="3">3</mat-option>
                      <mat-option value="4">4</mat-option>
                      <mat-option value="5">5</mat-option>
                      <mat-option value="6">6</mat-option>
                      <mat-option value="7">7</mat-option>
                      <mat-option value="8">8</mat-option>
                      <mat-option value="9">9</mat-option>
                      <mat-option value="10">10</mat-option>
                      <mat-option value="11">11</mat-option>
                      <mat-option value="12">12</mat-option>                    
                      <mat-option value="13">13</mat-option>  
                      <mat-option value="14">14</mat-option>   
                      <mat-option value="15">15</mat-option>   
                      <mat-option value="16">16</mat-option>   
                      <mat-option value="17">17</mat-option>   
                      <mat-option value="18">18</mat-option>   
                      <mat-option value="19">19</mat-option>   
                      <mat-option value="20">20</mat-option>   
                      <mat-option value="21">21</mat-option>   
                      <mat-option value="22">22</mat-option>   
                      <mat-option value="23">23</mat-option>   
                      <mat-option value="24">24</mat-option>   
                      <mat-option value="25">25</mat-option>   
                      <mat-option value="26">26</mat-option>   
                      <mat-option value="27">27</mat-option>   
                      <mat-option value="28">28</mat-option>   
                      <mat-option value="29">29</mat-option>   
                      <mat-option value="30">30</mat-option>   
                      <mat-option value="31">31</mat-option>   

                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="ShowYears == true">               

                  <mat-form-field>    
                    <mat-label>Select Month</mat-label>               
                    <mat-select formControlName="yearMonth">
                      <mat-option value="1">January</mat-option>
                      <mat-option value="2">February</mat-option>
                      <mat-option value="3">March</mat-option>
                      <mat-option value="4">April</mat-option>
                      <mat-option value="5">May</mat-option>
                      <mat-option value="6">June</mat-option>
                      <mat-option value="7">July</mat-option>
                      <mat-option value="8">August</mat-option>
                      <mat-option value="9">September</mat-option>
                      <mat-option value="10">October</mat-option>
                      <mat-option value="11">November</mat-option>
                      <mat-option value="12">December</mat-option>                    

                    </mat-select>
                  </mat-form-field>

                  <mat-form-field>       
                    <mat-label>Select day</mat-label>            
                    <mat-select formControlName="yearDay">
                      <mat-option value="1">1</mat-option>
                      <mat-option value="2">2</mat-option>
                      <mat-option value="3">3</mat-option>
                      <mat-option value="4">4</mat-option>
                      <mat-option value="5">5</mat-option>
                      <mat-option value="6">6</mat-option>
                      <mat-option value="7">7</mat-option>
                      <mat-option value="8">8</mat-option>
                      <mat-option value="9">9</mat-option>
                      <mat-option value="10">10</mat-option>
                      <mat-option value="11">11</mat-option>
                      <mat-option value="12">12</mat-option>                    
                      <mat-option value="13">13</mat-option>  
                      <mat-option value="14">14</mat-option>   
                      <mat-option value="15">15</mat-option>   
                      <mat-option value="16">16</mat-option>   
                      <mat-option value="17">17</mat-option>   
                      <mat-option value="18">18</mat-option>   
                      <mat-option value="19">19</mat-option>   
                      <mat-option value="20">20</mat-option>   
                      <mat-option value="21">21</mat-option>   
                      <mat-option value="22">22</mat-option>   
                      <mat-option value="23">23</mat-option>   
                      <mat-option value="24">24</mat-option>   
                      <mat-option value="25">25</mat-option>   
                      <mat-option value="26">26</mat-option>   
                      <mat-option value="27">27</mat-option>   
                      <mat-option value="28">28</mat-option>   
                      <mat-option value="29">29</mat-option>   
                      <mat-option value="30">30</mat-option>   
                      <mat-option value="31">31</mat-option>   

                    </mat-select>
                  </mat-form-field>
                  </ng-container>


                <p class="occurs">Ends On</p>
    
                <div class="endon">
                  <mat-radio-group name="end" color="primary" formControlName="repeatEnds">
                    <mat-radio-button value="never" [checked]="neverChecked"
                    (change)="neverChange($event)">Never</mat-radio-button>
                  </mat-radio-group>
                </div>
    
                <div class="endon">
                  <mat-radio-group name="end" color="primary" formControlName="repeatEnds">
                    <mat-radio-button value="on" [checked]="onChecked"
                    (change)="onChanges($event)">On</mat-radio-button>
                  </mat-radio-group>
    
                  <mat-form-field class="datefield">
                    <mat-label>End On</mat-label>
                    <input readonly matInput [matDatepicker]="picker33" formControlName="EndsOnDate">
                    <mat-datepicker-toggle matSuffix [for]="picker33" [disabled]="EndOnDate"></mat-datepicker-toggle>
                    <mat-datepicker #picker33></mat-datepicker>
                  </mat-form-field>
    
                </div>
    
                <div class="endon">
                  <mat-radio-group name="end" color="primary" formControlName="repeatEnds">
                    <mat-radio-button value="after" [checked]="afterChecked"
                    (change)="afterChanges($event)">After</mat-radio-button>
                  </mat-radio-group>
    
                  <div class="datefield">
                    <mat-form-field>
                      <mat-label>Occurence</mat-label>
                      <input [disabled]="Occurence" formControlName="occurances" matInput type="number" min="1" max="99" minlength="0" maxlength="2" 
                       (keypress)="numberOnlyForSch($event)"/>                     
                    </mat-form-field>
                  </div>
                </div>
    

              

              </div>    
               
             
  </div>
</mat-expansion-panel>

                       
    
            </div>



         <div class="reminder tschedule">
    
  <mat-expansion-panel  [expanded]="panelState" class="mat-elevation-z8 font-blue"  fxFlex>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="mlabel">Setup Email Notification</div> 
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
   
       <div class="selectedSchedule subtaskHolder NotiHolder">

                <!-- <label class="mlabel">Setup Email Notification</label> -->

                <mat-form-field class="example-full-width" *ngIf="showRepeatTaskEmail == true">                  
                  <input matInput  type="text" placeholder="Add Email" formControlName="repeatTaskEmail"
                  (input)="onRepeatTaskEmailChange($event.target.value)" >
                </mat-form-field>

                <form [formGroup]="dynamicFormNotification">
                  <div formArrayName="filtersmNotification">
                    <div  *ngFor="let filter of filtersFormArrayNotification.controls; let i = index;">

                      <div class="rep repNotification" [formGroupName]="i">

                       
                        <span class="noti" >Notification</span>
                        
                        <mat-form-field appearance="fill" class="time" >
                          <input type="number" matInput formControlName="timePeriodNumber" placeholder="Period" 
                          (keypress)="numberOnly($event)" min="1" max="31"   maxlength="2">
                        </mat-form-field>

                        <mat-form-field appearance="fill"  class="days">
                          <mat-select placeholder="Select Time Period" formControlName="timePeriodName">
                            <mat-option *ngFor="let stat of notificationdays" [value]="stat.name">
                              {{ stat.name }}
                          </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <button mat-icon-button class="remove"
                          (click)="removeFilterFromFiltersFormArrayNotification(i,filter.value)">
                          <mat-icon>remove_circle_outline</mat-icon>
                        </button>

                      </div>
                    </div>
                 
                    <button class="subtask" mat-stroked-button color="primary" *ngIf="filtersFormArrayNotification.length != 5" (click)="addFilterToFiltersFormArrayNotification()">
                      <mat-icon>add</mat-icon>
                      Notification
                    </button>

                    <p class="upto5" *ngIf="filtersFormArrayNotification.length == 5">Only upto 5 notications you can add.</p>

                  </div>
                </form>
              </div> 
               
             
  </div>
</mat-expansion-panel>

                       
    
            </div>

         

        
             <div class="reminder"  style="display: none">
              <div class="remind">
                <div class="mlabel">Reminder</div>
                <mat-slide-toggle color="primary"></mat-slide-toggle>
              </div>
    
              <div class="doubleBlock">
                <div class="blockHold">
                  <div class="tname">
                    <mat-form-field>
                      <mat-label>Send Through</mat-label>
                      <mat-select value="">
                        <mat-option value="">Email</mat-option>
                        <mat-option value="">SMS</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
    
                <div class="blockHold">
                  <div class="tname">
                    <mat-form-field>
                      <mat-label>Before</mat-label>
                      <mat-select value="">
                        <mat-option value="">30 min</mat-option>
                        <mat-option value="">60 min</mat-option>
                        <mat-option value="">1 hour</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
    
              </div>
    
              <div class="extrnalTask">
                <mat-checkbox color="primary">Custom</mat-checkbox>
              </div>
    
    
    
    
            </div>
          
         
    
            <div class="reminder tschedule" style="display: none;" >
    
              <div class="remind">
                <div class="mlabel">Schedule Repeating task</div>           
              </div>
    
    
              <mat-form-field>
                <mat-label>Schedule By</mat-label>
                <mat-select>             
                  <mat-option value="1">Specific Date </mat-option>
                  <mat-option value="2">Recurring</mat-option>
                  <mat-option value="3">According to another task</mat-option>
                </mat-select>
              </mat-form-field>
    
              <div class="selectedSchedule bydate" *ngIf="selectedValue == 1">
                <div class="bdivision">
                  <label>Schedule task by specific date</label>
                  <mat-checkbox checked color="primary">End Date</mat-checkbox>
                </div>
    
                <div class="specific">
    
                  <mat-form-field class="datefield">
                    <mat-label>Start date</mat-label>
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
    
                  <div class="field">
    
                    <ngx-timepicker-field></ngx-timepicker-field>
                  </div>
    
                </div>
    
                <div class="specific">
    
                  <mat-form-field class="datefield">
                    <mat-label>End date</mat-label>
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
    
                  <div class="field">
    
                    <ngx-timepicker-field></ngx-timepicker-field>
                  </div>
    
                </div>
    
              </div>
    
              <div class="selectedSchedule byrecurring" *ngIf="selectedValue == 2">
                <label>Recurring</label>
    
                <div class="specific">
    
                  <mat-form-field class="datefield">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="picker2">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
    
                  <div class="fieldr">
                    <mat-form-field>
                      <mat-label>Repeat every</mat-label>
                      <mat-select value="">
                        <mat-option value="">1</mat-option>
                        <mat-option value="">2</mat-option>
                        <mat-option value="">3</mat-option>
                        <mat-option value="">4</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
    
                  <div class="fieldr">
                    <mat-form-field>
                      <mat-label>Repeat</mat-label>
                      <mat-select value="">
                        <mat-option value="">day</mat-option>
                        <mat-option value="">week</mat-option>
                        <mat-option value="">month</mat-option>
                        <mat-option value="">year</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
    
                </div>
    
                <p class="occurs">Repeat On</p>
    
                <div class="everyday">
    
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">M</span>
                  </label>
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">T</span>
                  </label>
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">W</span>
                  </label>
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">T</span>
                  </label>
    
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">F</span>
                  </label>
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">S</span>
                  </label>
                  <label class="checkmark">
                    <input type="checkbox" checked="checked">
                    <span class="">S</span>
                  </label>
    
                </div>
    
                <p class="occurs">Ends On</p>
    
                <div class="endon">
                  <mat-radio-group name="end" color="primary">
                    <mat-radio-button value="1">Never</mat-radio-button>
                  </mat-radio-group>
                </div>
    
                <div class="endon">
                  <mat-radio-group name="end" color="primary">
                    <mat-radio-button value="1">On</mat-radio-button>
                  </mat-radio-group>
    
                  <mat-form-field class="datefield">
                    <mat-label>End On</mat-label>
                    <input matInput [matDatepicker]="picker3">
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                  </mat-form-field>
    
                </div>
    
                <div class="endon">
                  <mat-radio-group name="end" color="primary">
                    <mat-radio-button value="1">After</mat-radio-button>
                  </mat-radio-group>
    
                  <div class="datefield">
                    <mat-form-field>
                      <mat-label>Occurence</mat-label>
                      <mat-select value="">
                        <mat-option value="">1</mat-option>
                        <mat-option value="">5</mat-option>
                        <mat-option value="">10</mat-option>
                        <mat-option value="">15</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
    
              </div>
    
              <div class="selectedSchedule byanothertask" >
                <label>According to another task</label>
    
                <div class="specific">
    
    
    
                  <div class="fieldr">
                    <mat-form-field>
                      <mat-label>Due</mat-label>
                      <mat-select value="">
                        <mat-option value="">1</mat-option>
                        <mat-option value="">2</mat-option>
                        <mat-option value="">3</mat-option>
                        <mat-option value="">4</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
    
                  <div class="fieldr">
                    <mat-form-field>
                      <mat-label>Days</mat-label>
                      <mat-select value="">
                        <mat-option value="">Before</mat-option>
                        <mat-option value="">After</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
    
                  <div class="fieldr">
                    <mat-form-field class="">
                      <mat-label>Due date</mat-label>
                      <input matInput [matDatepicker]="picker3">
                      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                      <mat-datepicker #picker3></mat-datepicker>
                    </mat-form-field>
                  </div>
    
    
                </div>
                <div class="fullw">
                  <mat-form-field>
                    <mat-label>Task under </mat-label>
                    <mat-select value="">
                      <mat-option value="">Core</mat-option>
                      <mat-option value="">Contact</mat-option>
                      <mat-option value="">Company</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="fullw">
                  <mat-form-field>
                    <mat-label>Select task</mat-label>
                    <mat-select value="">
                      <mat-option value="">See how easy it is to customize Copper </mat-option>
                      <mat-option value="">Start to diagnose covid patients</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="fieldr">
                  <mat-form-field class="">
                    <mat-label>Due time</mat-label>
                    <input matInput>
                    <mat-datepicker-toggle matSuffix></mat-datepicker-toggle>
                    <mat-datepicker></mat-datepicker>
                  </mat-form-field>
                </div>
    
              </div>
    
    
    
            </div>
    
         
    
          </div>
        </mat-tab>
        <mat-tab label="Custom Fields">         
          <div class="detail" *ngIf="IsCustomFieldExist==false || IsCustomFieldExist==undefined">           
            <form [formGroup]="myFormGroup" class="reminder">
              <ng-container  *ngFor="let field of coreFieldList">
                <div *ngIf="field.fieldID==0 && field.data.length>1" class="fullw groupHolder" [ngSwitch]="field.fieldTypeName">
                  <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{field.data[0].groupName}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-card>
                      <div *ngFor="let grpField of field.data">
        
                        <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                          <ng-container *ngSwitchCase="'Textbox'">
                            <ng-container *ngIf="grpField.fieldName == 'Name'">
                              <div class="usernameinfo picorname">  
                                <div class="picname">
                                  <div class="upDoc">
                                    <img *ngIf="ImageUploadURL!=''" src="{{ ImageUploadURL }}" alt="" />
                                    <div class="uploadholder">
                                      <input type="file" alt="" (change)="onSelectFile($event)"  />
                                      <mat-icon>camera_alt</mat-icon>
                                    </div>
                                  </div>
                                  <div class="name">
                                    <mat-form-field>
                                      <input matTooltip="Readonly Field" matInput [required]="grpField.isRequired" [(ngModel)]="addByName" placeholder="{{ grpField.fieldName }}"
                                        formControlName="{{ grpField.fieldName }}" />
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
          
                            <ng-container *ngIf="grpField.fieldName != 'Name'">
                              <ng-container *ngIf="grpField.fieldNames.length > 0">
                                <div class="multipleBlock">
                                  <div class="multype">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)"
                                        formControlName="{{ grpField.fieldName + 'option' }}"
                                        placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of grpField.fieldNames">
                                          {{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field>
                                      <input *ngIf="grpField.fieldName == 'Phone'" matInput [required]="grpField.isRequired"
                                        placeholder="Add Phone" value=""
                                        formControlName="{{ grpField.fieldName }}" 
                                        mask="(000) 000-0000" 
                                        [readonly] = "grpField.rolePermission==1"/>
                                        
                                      <input *ngIf="grpField.fieldName != 'Phone'" [required]="grpField.isRequired"
                                        placeholder="{{ grpField.placeholder }}" matInput value=""
                                        formControlName="{{ grpField.fieldName }}"
                                        [readonly] = "grpField.rolePermission==1" />
          
                                    </mat-form-field>
                                    <div class="inOline" *ngIf="grpField.fieldName == 'Address'">
          
                                      <div class="divide">
                                        <mat-form-field class="example-full-width">
                                          <input type="text"
                                                 placeholder="City" aria-label="Number" matInput
                                          (input)="searchCity($event.target.value)" formControlName="City" [matAutocomplete]="auto"
                                          [readonly] = "grpField.rolePermission==1">
                                        <mat-autocomplete #auto="matAutocomplete">
                                          <mat-option *ngFor="let option of cityOption" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
            
                                      </mat-form-field>
                                      </div>
          
                                      <div class="divide">
                                        <mat-form-field >
                                          <mat-label>State</mat-label>
                                          <mat-select [disabled] = "grpField.rolePermission==1" formControlName="State"  placeholder="State">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
          
                                        
                                      </div>
          
                                      <div class="divide">
                                        <mat-form-field class="example-full-width">
                                          <input type="text" matInput placeholder="Zip Code" aria-label="Number"
                                        (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                        [matAutocomplete]="ZipCode" [readonly] = "grpField.rolePermission==1">
                                      <mat-autocomplete #ZipCode="matAutocomplete">
                                        <mat-option *ngFor="let option of zipOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                        </mat-form-field>
          
                                      </div>                           
          
                                    </div>
          
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
                                </div>
          
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">
          
                                  <div class="multype" *ngFor="let element of dynamicArray; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                          element.fieldName + (i + 1) + 'option'
                                        }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
          
          
                                    <mat-form-field class="extraInput">
                                      <mat-label>Add Email</mat-label>
                                      <input matInput formControlName="{{ element.fieldName + (i + 1) }}"
                                      [readonly] = "grpField.rolePermission==1" placeholder="Add Email">
          
                                    </mat-form-field>
          
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
                                </div>
          
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                                  <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                          element.fieldName + (i + 1) + 'option'
                                        }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
          
          
                                    <mat-form-field class="example-full-width">
                                      <mat-label>Add Phone</mat-label>
                                      <input matInput mask="(000) 000-0000" matInput formControlName="{{ element.fieldName + (i + 1) }}"
                                      [readonly] = "grpField.rolePermission==1" placeholder="Add Phone">
          
                                    </mat-form-field>
          
                                    <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                  </div>
                                </div>
          
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'Address'">
                                  
                                  <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                          element.fieldName + (i + 1) + 'option'
                                        }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
          
          
                                    <mat-form-field class="example-full-width">
                                      <mat-label>Street</mat-label>
                                      <input  matInput placeholder="Street" value=""
                                      formControlName="{{ element.fieldName + (i + 1) }}" 
                                      [readonly] = "grpField.rolePermission==1"/>
                                    </mat-form-field>
          
                                   
                                    <div class="inOline">
          
                                      <div class="divide">
          
          
          
                                        <mat-form-field class="example-full-width">
                                          <input type="text" matInput
                                          placeholder="City" aria-label="Number" 
                                          (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                          [matAutocomplete]="auto" [readonly] = "grpField.rolePermission==1">
                                          <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of cityOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field>
                                     
                                      </div>
          
                                      <div class="divide">
                                       
                                        <mat-form-field appearance="">
                                          <mat-label>State</mat-label>
                                          <mat-select [disabled] = "grpField.rolePermission==1" formControlName="State{{ (i + 1) }}"  placeholder="State">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
          
          
                                       
                                      </div>
          
                                      <div class="divide">
          
                                        <mat-form-field class="example-full-width">
                                          <input matInput
                                          type="text" placeholder="Zip Code" aria-label="Number" 
                                          (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                          [matAutocomplete]="ZipCode" [readonly] = "grpField.rolePermission==1">
                                          <mat-autocomplete #ZipCode="matAutocomplete">
                                            <mat-option *ngFor="let option of zipOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field>                             
                                      </div>                            
          
                                    </div>
                                    
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                      *ngIf="grpField.fieldNames.length > 0">
                                      Add more</span>
                                </div>
          
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'WebSite'">
                                  <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                          element.fieldName + (i + 1) + 'option'
                                        }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
          
                                    <mat-form-field class="example-full-width">
                                      <mat-label>WebSite</mat-label>
                                      <input matInput placeholder="WebSite" value=""
                                      formControlName="{{ element.fieldName + (i + 1) }}" 
                                      [readonly] = "grpField.rolePermission==1"/>
                                    </mat-form-field>
          
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                  *ngIf="grpField.fieldNames.length > 0">
                                  Add more</span>
                                </div>
                              </ng-container>
          
                              <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}" [readonly] = "grpField.rolePermission==1"
                                  formControlName="{{ grpField.fieldName }}" />
                              </mat-form-field>
                            </ng-container>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Textarea'">
                            <mat-form-field>
                              <textarea matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}" [readonly] = "grpField.rolePermission==1"
                                formControlName="{{ grpField.fieldName }}" >
                              </textarea>
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Number'">
                            <mat-form-field>
                              <input matInput [required]="grpField.isRequired" (keypress)="numberOnly($event)" [readonly] = "grpField.rolePermission==1"
                                placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" />
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Currency'">
                            <mat-form-field>
                              <input matInput [required]="grpField.isRequired" [readonly] = "grpField.rolePermission==1"
                                placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" />
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Address'">
                            <mat-form-field>
                              <input matInput [required]="grpField.isRequired" [readonly] = "grpField.rolePermission==1"
                                placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" />
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Image'">
          
                            <mat-label>{{ grpField.fieldName }}</mat-label>
                            <div class="pic">
                              <input type="file" placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" [readonly] = "grpField.rolePermission==1"
                                (change)="onSelectFile($event)" />
                              <span class="ico">
                                <mat-icon>add_a_photo</mat-icon>
                              </span>
                            </div>
          
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Date'">
                            <mat-form-field>
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <input matInput [required]="grpField.isRequired" [matDatepicker]="basicDatepicker" [readonly] = "grpField.rolePermission==1"
                                placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" />
                              <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                              <mat-datepicker #basicDatepicker></mat-datepicker>
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'URL'">
                            <mat-form-field>
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}" [readonly] = "grpField.rolePermission==1"
                                formControlName="{{ grpField.fieldName }}" />
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'Dropdown'">
                            <mat-form-field>
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-select [required]="grpField.isRequired" formControlName="{{ grpField.fieldName }}" [disabled]="grpField.rolePermission==1">
                                <mat-option *ngFor="let drp of getdropdownlist(grpField.fieldName)" [value]="drp">
                                  {{ drp }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </ng-container>
          
                          <ng-container *ngSwitchCase="'MultiSelect'">
                            <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                                <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                                  (removed)="remove(tag)">
                                  {{tag}}
                                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                </mat-chip>
                                <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                  (matChipInputTokenEnd)="add($event)">
                              </mat-chip-list>
                              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                                  {{tag}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
              
                            <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-select [disabled] = "grpField.rolePermission==1" [required]='grpField.isRequired' multiple
                                formControlName="{{ grpField.fieldName }}">
                                <mat-option *ngFor="
                                    let muldrp of getMuldropdownlist(grpField.fieldName)
                                  " [value]="muldrp">
                                  {{ muldrp }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            
                          </ng-container>          
                      
                          <ng-container *ngSwitchCase="'Checkbox'">
                            <mat-label>{{ grpField.fieldName }}</mat-label>
                            <ul class="check">
                              <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                                <mat-checkbox [disabled]="grpField.rolePermission==1" color="primary" (change)="OnChange($event, chk, grpField.fieldID)">
                                  {{ chk }}
                                </mat-checkbox>
                              </li>
                            </ul>
                          </ng-container>
                        </div>
                      </div>
                    </mat-card>
                  </mat-expansion-panel>
                </div>
                <div class="fullw" [ngSwitch]="field.fieldTypeName">
                  <ng-container *ngSwitchCase="'Textbox'">
                    <ng-container *ngIf="field.fieldName == 'Name'">
                      <div class="usernameinfo picorname">
                        <div class="picname">
                          
                          <div class="name">
        
                            <mat-form-field>
                              <mat-label>{{ field.fieldName }}</mat-label>
                              <input matInput matTooltip="Readonly Field" [required]="field.isRequired" [(ngModel)]="addByName" placeholder="{{ field.placeholder }}"
                                formControlName="{{ field.fieldName }}" 
                                (input)="CheckName($event.target.value)"/>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </ng-container>
        
                    <ng-container *ngIf="field.fieldName != 'Name'">
                      <ng-container *ngIf="field.fieldNames.length > 0">
                        <div class="multipleBlock">
                          <div class="multype">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)"
                                formControlName="{{ field.fieldName + 'option' }}"
                                placeholder="{{ field.fieldNames[0].fieldName }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of field.fieldNames">
                                  {{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>{{ field.fieldName }}</mat-label>
                              <input matInput *ngIf="field.fieldName == 'Phone'" [required]='field.isRequired'
                                placeholder="Add Phone" value="" formControlName="{{ field.fieldName }}"
                                mask="(000) 000-0000" [readonly] = "field.rolePermission==1" />
                              <input matInput *ngIf="field.fieldName  != 'Phone'" [required]='field.isRequired'
                                placeholder="{{ field.placeholder }}" value="" formControlName="{{ field.fieldName }}"
                                [readonly] = "field.rolePermission==1" />
                            </mat-form-field>
        
                            <div class="AddressHolder" *ngIf="field.fieldName == 'Address'">
                              <div class="inOline">
        
                                <div class="divide">
                                  <mat-form-field class="example-full-width">
                                  <input matInput type="text"  maxlength="30" [(ngModel)]="cityValue" placeholder="City" aria-label="Number"
                                     (input)="searchCity($event.target.value)" formControlName="City"
                                    [matAutocomplete]="auto" [readonly] = "field.rolePermission==1">
                                    <mat-autocomplete #auto="matAutocomplete">
                                      <mat-option *ngFor="let option of cityOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                </div>
        
                                <div class="divide">
                                  
                                  <mat-form-field >
                                    <mat-label>State</mat-label>
                                    <mat-select [disabled] = "field.rolePermission==1" [(ngModel)]="stateValue" formControlName="State" placeholder="State">
                                      <mat-option>None</mat-option>
                                      <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  
                                </div>
        
                                <div class="divide">
                                  <mat-form-field class="example-full-width">
                                  <input type="text" [(ngModel)]="zipValue" placeholder="Zip Code" aria-label="Number"
                                  matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                    [matAutocomplete]="ZipCode" [readonly] = "field.rolePermission==1">
                                  <mat-autocomplete #ZipCode="matAutocomplete">
                                    <mat-option *ngFor="let option of zipOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                  </mat-form-field>
                                </div>
        
        
        
                              </div>
        
                            </div>
        
        
                            
                          </div>
                          <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                            Add more</span>
                        </div>
        
                        <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">
                          <div class="multype" *ngFor="let element of dynamicArray; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                    element.fieldName + (i + 1) + 'option'
                                  }}" placeholder="{{ field.fieldNames[0].fieldName }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
        
                            <mat-form-field class="extraInput">
                              <mat-label>Add Email</mat-label>
                              <input matInput formControlName="{{ element.fieldName + (i + 1) }}" placeholder="Add Email"
                              [readonly] = "field.rolePermission==1">
                            </mat-form-field>
        
                            
                          </div>
                          <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                            Add more</span>
                        </div>
        
                        <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                          <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                    element.fieldName + (i + 1) + 'option'
                                  }}" placeholder="{{ field.fieldNames[0].fieldName }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
        
                            <mat-form-field class="example-full-width">
                              <mat-label>Add Phone</mat-label>
                              <input matInput mask="(000) 000-0000" formControlName="{{ element.fieldName + (i + 1) }}"
                              [readonly] = "field.rolePermission==1" placeholder="Add Phone">
                            </mat-form-field>
        
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more</span>
                          </div>
                        </div>
        
                        <div class="multipleBlock" *ngIf="field.fieldName == 'Address'">
                          <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                    element.fieldName + (i + 1) + 'option'
                                  }}" placeholder="{{ field.fieldNames[0].fieldName }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
        
                            <mat-form-field class="example-full-width">
                              <mat-label>Street</mat-label>
                              <input matInput placeholder="Street" value=""
                              formControlName="{{ element.fieldName + (i + 1) }}"
                              [readonly] = "field.rolePermission==1" />
                            </mat-form-field>
        
                            
        
                            <div class="inOline">
        
                              <div class="divide">
                                <mat-form-field class="example-full-width">
                                <input placeholder="City" aria-label="Number" value="" matInput
                                  (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                  [matAutocomplete]="auto" [readonly] = "field.rolePermission==1">
                                  <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of cityOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>
        
                              <div class="divide">
                                
                                <mat-form-field >
                                  <mat-label>State</mat-label>
                                <mat-select [disabled] = "field.rolePermission==1" formControlName="State{{ (i + 1) }}"  placeholder="State">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                                </mat-form-field>
                              </div>
        
                              <div class="divide">
                                <mat-form-field class="example-full-width">
                                <input type="text" placeholder="Zip Code" aria-label="Number" matInput
                                  (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                  [matAutocomplete]="ZipCode" [readonly] = "field.rolePermission==1">
                                <mat-autocomplete #ZipCode="matAutocomplete">
                                  <mat-option *ngFor="let option of zipOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                              </div>
        
        
        
        
        
                            </div>
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more</span>
                          </div>
                        </div>
        
                        <div class="multipleBlock" *ngIf="field.fieldName == 'WebSite'">
                          <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                    element.fieldName + (i + 1) + 'option'
                                  }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
        
                            <mat-form-field appearance="">
                              <mat-label>WebSite</mat-label>
                              <input  matInput placeholder="" value=""
                              formControlName="{{ element.fieldName + (i + 1) }}"
                              [readonly] = "field.rolePermission==1" />
                              </mat-form-field>
                            
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more</span>
                          </div>
                        </div>
                      </ng-container>
        
                      <mat-form-field *ngIf="field.fieldNames.length === 0">
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input matInput placeholder=" {{ field.placeholder }}" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                          formControlName="{{ field.fieldName }}" />
                      </mat-form-field>
                    </ng-container>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'Textarea'">
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <textarea matInput placeholder="{{ field.placeholder }}" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                        formControlName="{{ field.fieldName }}" >
                      </textarea>
                    </mat-form-field>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'Number'">
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput (keypress)="numberOnly($event)" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                        placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" />
                    </mat-form-field>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'Currency'">
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                        placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" />
                    </mat-form-field>
                  </ng-container>
                 
                  <ng-container *ngSwitchCase="'Address'">
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                        placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" />
                    </mat-form-field>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'Image'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <div class="pic">
                      <input type="file" placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}" [readonly] = "field.rolePermission==1"
                        (change)="onSelectFile($event)" />
                      <span class="ico">
                        <mat-icon>add_a_photo</mat-icon>
                      </span>
                    </div>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'Date'">
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput [matDatepicker]="basicDatepicker" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                        placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" />
                      <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #basicDatepicker></mat-datepicker>
                    </mat-form-field>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'URL'">
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput placeholder="{{ field.placeholder }}" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                        formControlName="{{ field.fieldName }}" />
                    </mat-form-field>
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'Dropdown'">
                    <mat-form-field *ngIf="field.fieldName == 'Type'">
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <mat-select [required]="field.isRequired" formControlName="{{ field.fieldName }}"
                        (selectionChange)="getSubFolderFields($event,field.fieldName)">
                        <mat-option *ngFor="let typelist of AllTypeList" [value]="typelist.subFolderID">
                          {{typelist.folderName}}
                        </mat-option>
                      </mat-select>
        
                    </mat-form-field>
        
                    <mat-form-field *ngIf="field.fieldName != 'Type'">
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <mat-select [required]="field.isRequired" formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                        <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                          {{ drp }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
        
                  </ng-container>
        
                  <ng-container *ngSwitchCase="'MultiSelect'">
        
                    <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <mat-chip-list [required]="field.isRequired" #chipList aria-label="Fruit selection">
                        <mat-chip *ngFor="let fruit of tags" [selectable]="selectable" [removable]="removable"
                          (removed)="remove(fruit)">
                          {{fruit}}
                          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                        <input matInput placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" 
                          id="fruitCtrlid"   [matAutocomplete]="auto"
                          [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="add($event)">
                      </mat-chip-list>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                        <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                          {{fruit}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
        
        
                    <mat-form-field *ngIf="field.fieldName != 'Tags'">
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <mat-select [required]="field.isRequired" multiple formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                        <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                          {{ muldrp }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
        
        
                  </ng-container>
                
        
                  <ng-container *ngSwitchCase="'Checkbox'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <ul class="check">
                      <li *ngFor="let chk of getCheckBoxlist(field.fieldName)">
                        <mat-checkbox [disabled]="field.rolePermission==1" color="primary" (change)="OnChange($event, chk, field.fieldID)">
                          {{ chk }}
                        </mat-checkbox>
                      </li>
                    </ul>
                  </ng-container>
                </div>
              </ng-container>
            </form>
          </div>
          <div class="detail" *ngIf="IsCustomFieldExist==true">
           
            <div class="usernameinfo">
              <!-- <div class="userNameInformation">
                <div class="picname">
                  <div class="upDoc ">
                    <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http';" >              
                        <img src="{{ ImagePathURL }}" />            
                    </ng-container>
         
                    <div class="uploadholder">
                      <input type="file" alt="" (change)="onSelectFile($event)" />
                      <mat-icon>camera_alt</mat-icon>
                    </div>
                  </div>
                </div>
          
                <div class="pmenu">
                </div>
              </div> -->
              <!-- Quick action are commented for some time-->
              <!-- <div class="quick">
                <button mat-icon-button matTooltip="Add Document" matTooltipClass="tooltip" ><mat-icon>description</mat-icon></button>
                <button mat-icon-button matTooltip="Add Activity" matTooltipClass="tooltip" ><mat-icon>touch_app</mat-icon></button>
                <button mat-icon-button matTooltip="Add Task" matTooltipClass="tooltip" ><mat-icon>task_alt</mat-icon></button>
                <button mat-icon-button matTooltip="Add Process Intelligence" matTooltipClass="tooltip" ><mat-icon>ac_unit</mat-icon></button>
                <button mat-icon-button matTooltip="Add Photo" matTooltipClass="tooltip" ><mat-icon>add_photo_alternate</mat-icon></button>
              </div> -->
            </div>
        
              <div class="compdetail">
                <form [formGroup]="myFormGroup" class="reminder" >
                  <ng-container *ngFor="let field of coreUserList">
                    <div *ngIf="field.fieldID==0 && field.data.length>0" class="fullw groupHolder" [ngSwitch]="field.fieldTypeName">
                      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                          {{field.data[0].groupName}}   
                        </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngFor="let grpField of field.data"> 
                        
                          <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                            <ng-container *ngSwitchCase="'Textbox'">
                              <ng-container *ngIf="grpField.fieldName == 'Name'">
                                      <mat-form-field>
                                        <input
                                          matInput
                                          matTooltip="Readonly Field"
                                          [required]="grpField.isRequired"
                                          placeholder="{{ grpField.fieldName }}"
                                          [(ngModel)]="addByName"
                                          formControlName="{{ grpField.fieldName }}"
                                         
                                        />                            
                
                                      
                                      </mat-form-field>
                              </ng-container>
                
                              <ng-container *ngIf="grpField.fieldName != 'Name'">
                                <ng-container *ngIf="grpField.fieldNames.length > 0">
                                  <div class="multipleBlock">
                                    <div class="multype">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select
                                          (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{ grpField.fieldName + 'option' }}"
                                          placeholder="{{ grpField.placeholderVal }}">
                                          <mat-option
                                            value="{{ names.fieldNameID }}"
                                            *ngFor="let names of grpField.fieldNames">
                                            {{ names.fieldName }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-form-field>
                                        <input [required]="grpField.isRequired"
                                        *ngIf="grpField.fieldName == 'Phone'"
                                          matInput
                                        placeholder="Add Phone"
                                        [(ngModel)]="grpField.fieldValue"
                                        formControlName="{{ grpField.fieldName }}"
                                        mask="(000) 000-0000"
                                        [readonly] = "grpField.rolePermission==1"/>
                                      <input [required]="grpField.isRequired"
                                        *ngIf="grpField.fieldName != 'Phone'"
                                        matInput
                                        placeholder="Add {{ grpField.placeholder }}"
                                        [(ngModel)]="grpField.fieldValue"
                                        formControlName="{{ grpField.fieldName }}"
                                        [readonly] = "grpField.rolePermission==1"/>
                                      </mat-form-field>
                                      
                                      <div class="inOline" *ngIf="grpField.fieldName == 'Address'">
          
                                        <div class="divide">
                                          <mat-form-field>
                                            <input type="text"
                                            placeholder="City"
                                            [(ngModel)]="cityValue"
                                            aria-label="Number"
                                            matInput
                                            (input)="searchCity($event.target.value)"
                                            formControlName="City"
                                            [matAutocomplete]="auto" [readonly] = "grpField.rolePermission==1">
                                          <mat-autocomplete #auto="matAutocomplete">
                                          <mat-option *ngFor="let option of cityOption" [value]="option">
                                           {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                          </mat-form-field>
                                        </div>
          
                                        <div class="divide">
                                          <mat-form-field>
                                            <mat-select [disabled] = "grpField.rolePermission==1" [(ngModel)]="stateValue" formControlName="State" placeholder="State">
                                              <mat-option>None</mat-option>
                                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
          
                                        <div class="divide">
                                          <mat-form-field>
                                            <input type="text"
                                          placeholder="Zip Code"
                                          aria-label="Number"
                                          [(ngModel)]="zipValue"
                                           matInput
                                          (input)="searchZip($event.target.value)"
                                          formControlName="ZipCode"
                                          [matAutocomplete]="ZipCode" [readonly] = "grpField.rolePermission==1">
                                    <mat-autocomplete #ZipCode="matAutocomplete">
                                     <mat-option *ngFor="let option of zipOption" [value]="option">
                                     {{option}}
                                   </mat-option>
                                 </mat-autocomplete>
                                          </mat-form-field>
                                        </div>
          
                       
                              </div>
                                
                                      
                                    </div>
                                    <span
                                        class="addmore"
                                        (click)="addMoreEditField(grpField.fieldName)"
                                        *ngIf="grpField.fieldNames.length > 0">
                                        Add more</span>
                                  </div>
                
                                  <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">
                                    <div
                                      class="multype"
                                      *ngFor="let element of dynamicArray; let i = index">
                                      
          
                                      <div class="primaryEmail" >
                                        <mat-form-field class="mulDropdown" appearance="">
                                          <mat-select
                                            (selectionChange)="clearPlaceholder($event)"
                                            formControlName="{{element.fieldName + 'option'}}"
                                            placeholder="{{ element.placeholderVal }}">
                                            <mat-option
                                              value="{{ names.fieldNameID }}"
                                              *ngFor="let names of element.fieldNames;
                                                trackby: fieldNameID">{{ names.fieldName }}
                                              </mat-option>
                                          </mat-select>
                                        </mat-form-field>
          
                                        <!-- <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"> Primary</div> -->
                                        
                                        </div>
                                      
                                        <mat-form-field>
                                          <input
                                          matInput
                                          placeholder="Add Email"
                                         [(ngModel)]="element.fieldValue"
                                          formControlName="{{ element.fieldName}}"
                                          [readonly] = "grpField.rolePermission==1"
                                          pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                                        />
                                        </mat-form-field>
                                      
                                    </div>
                                    <span
                                        class="addmore"
                                        (click)="addMoreEditField(grpField.fieldName)"
                                        *ngIf="grpField.fieldNames.length > 0">
                                        Add more</span>
                                  </div>
                
                                  <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                                    <div
                                      class="multype"
                                      *ngFor="let element of dynamicArrayPhone; let i = index">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select
                                          (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{
                                            element.fieldName  + 'option'
                                          }}"
                                          placeholder="{{ grpField.fieldNames[0].fieldName }}"
                                        >
                                          <mat-option
                                            value="{{ names.fieldNameID }}"
                                            *ngFor="
                                              let names of element.fieldNames;
                                              trackby: fieldNameID
                                            "
                                            >{{ names.fieldName }}</mat-option
                                          >
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-form-field>
                                        <input
                                        
                                        matInput
                                        mask="(000) 000-0000"
                                        [(ngModel)]="element.fieldValue"
                                        placeholder="Add Phone"
                                        formControlName="{{ element.fieldName }}"
                                        [readonly] = "grpField.rolePermission==1"
                                      />
                                      </mat-form-field>
                                      
                                      
                                    </div>
                                    <span
                                        class="addmore"
                                        (click)="addMoreEditField(grpField.fieldName)"
                                        *ngIf="grpField.fieldNames.length > 0"
                                      >
                                        Add more</span
                                      >
                                  </div>
                
                                  <div
                                    class="multipleBlock"
                                    *ngIf="grpField.fieldName == 'Address'"
                                  >
                                    <div
                                      class="multype"
                                      *ngFor="let element of dynamicArrayAddress; let i = index"
                                    >
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select
                                         [ngModel]="element.fieldNameID"
                                          (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{
                                            element.fieldName + 'option'
                                          }}"
                                          placeholder="{{ element.placeholderVal }}"
                                        >
                                          <mat-option
                                            value="{{ names.fieldNameID }}"
                                            *ngFor="
                                              let names of element.fieldNames;
                                              trackby: fieldNameID
                                            "
                                            >{{ names.fieldName }}</mat-option
                                          >
                                        </mat-select>
                                      </mat-form-field>
                                      
                                      <mat-form-field>
                                        <input
                                        matInput
                                        placeholder="Add Address"
                                        [(ngModel)]="element.fieldValue"
                                        formControlName="{{ element.fieldName }}"
                                        [readonly] = "grpField.rolePermission==1"
                                      />
                                      </mat-form-field>
                                      
                                      <div *ngIf="element.address.length>0"  class="inOline">
                                        <ng-container  *ngFor=" let adr of element.address;" >
                                        
          
                                        <!-- <div class="divide">
                                          <mat-form-field> -->
                                            <input *ngIf="adr.childFieldType==3"
                                      placeholder="City"
                                      aria-label="Number"
                                      matInput
                                      [ngModel]="adr.fieldValue"
                                      (input)="searchCity($event.target.value)"
                                      formControlName="City{{(i + 1) }}"
                                      [matAutocomplete]="auto"
                                      [readonly] = "grpField.rolePermission==1">
                               <mat-autocomplete #auto="matAutocomplete">
                                 <mat-option *ngFor="let option of cityOption" [value]="option">
                                   {{option}}
                                 </mat-option>
                               </mat-autocomplete>
                                          <!-- </mat-form-field>
                                        </div> -->
          
                                        <!-- <div class="divide">
                                          <mat-form-field> -->
                                            <mat-select [disabled] = "grpField.rolePermission==1" [ngModel]="adr.fieldValue" *ngIf="adr.childFieldType==2"  formControlName="State{{ (i + 1) }}"
                                             placeholder="State">
                                              <mat-option>None</mat-option>
                                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                            </mat-select>
                                          <!-- </mat-form-field>
                                        </div> -->
                                          
                                       
                                        <!-- <div class="divide">
                                          <mat-form-field> -->
                                            <input  *ngIf="adr.childFieldType==4"
                                  placeholder="Zip Code"
                                  [ngModel]="adr.fieldValue"
                                  aria-label="Number"
                                  matInput
                                  (input)="searchZip($event.target.value)"
                                  formControlName="ZipCode{{ (i + 1) }}"
                                  [matAutocomplete]="ZipCode"
                                  [readonly] = "grpField.rolePermission==1">
                           <mat-autocomplete #ZipCode="matAutocomplete">
                             <mat-option *ngFor="let option of zipOption" [value]="option">
                               {{option}}
                             </mat-option>
                           </mat-autocomplete>
                                          <!-- </mat-form-field>
                                        </div> -->
                                   
                              
                                </ng-container>
                                  </div>
                                    <div *ngIf="element.address.length==0" class="inOline">
          
                                      <div class="divide">
                                        <mat-form-field>
                                          <input 
                                          placeholder="City"
                                          aria-label="Number"
                                          matInput
                                          (input)="searchCity($event.target.value)"
                                          formControlName="City{{(i + 1) }}"
                                          [matAutocomplete]="auto"
                                          [readonly] = "grpField.rolePermission==1">
                                   <mat-autocomplete #auto="matAutocomplete">
                                     <mat-option *ngFor="let option of cityOption" [value]="option">
                                       {{option}}
                                     </mat-option>
                                   </mat-autocomplete>
                                        </mat-form-field>
                                      </div>
          
                                      <div class="divide">
                                        <mat-form-field>
                                          <mat-select [disabled] = "grpField.rolePermission==1"  formControlName="State{{ (i + 1) }}"
                                           placeholder="State">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
          
                                      <div class="divide">
                                        <mat-form-field>
                                          <input 
                                  placeholder="Zip Code"
                                  aria-label="Number"
                                 matInput
                                  (input)="searchZip($event.target.value)"
                                  formControlName="ZipCode{{ (i + 1) }}"
                                  [matAutocomplete]="ZipCode"
                                  [readonly] = "grpField.rolePermission==1">
                           <mat-autocomplete #ZipCode="matAutocomplete">
                             <mat-option *ngFor="let option of zipOption" [value]="option">
                               {{option}}
                             </mat-option>
                           </mat-autocomplete>
                                        </mat-form-field>
                                      </div>
          
          
                                      
                                
                                    </div>
                                      
                                    </div>
                                    <span
                                        class="addmore"
                                        (click)="addMoreEditField(grpField.fieldName)"
                                        *ngIf="grpField.fieldNames.length > 0"
                                      >
                                        Add more</span
                                      >
                                  </div>
                
                                  <div
                                    class="multipleBlock"
                                    *ngIf="grpField.fieldName == 'WebSite'"
                                  >
                                    <div
                                      class="multype"
                                      *ngFor="let element of dynamicArrayWebsite; let i = index"
                                    >
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select
                                          (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{
                                            element.fieldName + 'option'
                                          }}"
                                        >
                                          <mat-option
                                            value="{{ names.fieldNameID }}"
                                            *ngFor="
                                              let names of element.fieldNames;
                                              trackby: fieldNameID
                                            "
                                            >{{ names.fieldName }}</mat-option
                                          >
                                        </mat-select>
                                      </mat-form-field>
          
          
                                      <mat-form-field>
                                        <input
                                        matInput
                                        placeholder="WebSite"
                                        [(ngModel)]="element.fieldValue"
                                        formControlName="{{ element.fieldName }}"
                                        [readonly] = "grpField.rolePermission==1"
                                      />
                                      </mat-form-field>
                                      
                                      
                                    </div>
                                    <span
                                        class="addmore"
                                        (click)="addMoreEditField(grpField.fieldName)"
                                        *ngIf="grpField.fieldNames.length > 0"
                                      >
                                        Add more</span
                                      >
                                  </div>
                                </ng-container>
                
                                <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                                [readonly] = "grpField.rolePermission==1" />
                                </mat-form-field>
                              </ng-container>
                            </ng-container>
                
                            <ng-container *ngSwitchCase="'Textarea'">
                              <mat-form-field>
                                <textarea
                                  [required]="grpField.isRequired"
                                  matInput
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  [readonly] = "grpField.rolePermission==1">
                                </textarea>
                              </mat-form-field>
                            </ng-container>
                
                            <ng-container *ngSwitchCase="'Number'">
                              <mat-form-field>
                                <input
                                [required]="grpField.isRequired"
                                  matInput
                                  (keypress)="numberOnly($event)"
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  [readonly] = "grpField.rolePermission==1"/>
                              </mat-form-field>
                            </ng-container>
          
                            <ng-container *ngSwitchCase="'Currency'">
                              <mat-form-field>
                                <input
                                [required]="grpField.isRequired"
                                  matInput                      
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  [readonly] = "grpField.rolePermission==1"/>
                              </mat-form-field>
                            </ng-container>
          
                            <ng-container *ngSwitchCase="'Address'">
                              <mat-form-field>
                                <input
                                [required]="grpField.isRequired"
                                  matInput                      
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  [readonly] = "grpField.rolePermission==1"/>
                              </mat-form-field>
                            </ng-container>
                
                            <ng-container *ngSwitchCase="'Image'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <div class="pic">
                                <input
                                  type="file"
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  (change)="onSelectFile($event)"
                                  [readonly] = "grpField.rolePermission==1"
                                />                    
                                <span class="ico">
                                  <mat-icon>add_a_photo</mat-icon>
                                </span>
                              </div>                   
                            </ng-container>
                
                            <ng-container *ngSwitchCase="'Date'">
                              <mat-form-field>
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <input
                                  [required]="grpField.isRequired"
                                  matInput
                                  [matDatepicker]="basicDatepicker"
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  [readonly] = "grpField.rolePermission==1"
                                />
                                <mat-datepicker-toggle
                                  matSuffix
                                  [for]="basicDatepicker"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #basicDatepicker></mat-datepicker>
                              </mat-form-field>
                            </ng-container>
                
                            <ng-container *ngSwitchCase="'URL'">
                              <mat-form-field>
                                <input [required]="grpField.isRequired"
                                  matInput
                                  placeholder="{{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}"
                                  [readonly] = "grpField.rolePermission==1"
                                />
                              </mat-form-field>
                            </ng-container>
                
                            <ng-container *ngSwitchCase="'Dropdown'">
                              <mat-form-field>
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-select [disabled] = "grpField.rolePermission==1"  [ngModel]="getddlSelectedVal(grpField.fieldName)"
                                [required]="grpField.isRequired" formControlName="{{ grpField.fieldName }}">
                                  <mat-option
                                    *ngFor="let drp of getdropdownlist(grpField.fieldName)"
                                    [value]="drp"
                                  >
                                    {{ drp }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </ng-container>
          
                            <ng-container *ngSwitchCase="'MultiSelect'">
                              <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                                  <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                                    (removed)="remove(tag)">
                                    {{tag}}
                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                  </mat-chip>
                                  <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="add($event)">
                                </mat-chip-list>
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                  <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                                    {{tag}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                
                              <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-select [disabled] = "grpField.rolePermission==1" [required]='grpField.isRequired' multiple [ngModel]="getMultiddlSelectedVal(grpField.fieldName)"
                                  formControlName="{{ grpField.fieldName }}">
                                  <mat-option *ngFor="
                                      let muldrp of getMuldropdownlist(grpField.fieldName)
                                    " [value]="muldrp">
                                    {{ muldrp }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              
                            </ng-container>
                
                            <!-- <ng-container *ngSwitchCase="'MultiSelect'">
                              <mat-form-field>
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired"
                                [ngModel]="getMultiddlSelectedVal(grpField.fieldName)" multiple formControlName="{{ grpField.fieldName }}">
                                  <mat-option
                                    *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)"
                                    [value]="muldrp">
                                    {{ muldrp }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </ng-container> -->
                
                            <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName ==='Tags'">
                              <mat-form-field class="example-chip-list">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Fruit selection">
                                  <mat-chip
                                    *ngFor="let fruit of filteredFruits"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="remove(fruit)">
                                    {{fruit}}
                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                  </mat-chip>
                                  <input
                                    placeholder="Add Tags"
                                    #fruitInput
                                    [formControl]="fruitCtrl"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="add($event)"
                                    [readonly] = "grpField.rolePermission==1">
                                </mat-chip-list>
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                  <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                                    {{fruit}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </ng-container>                     -->
                                  
          
                            <ng-container *ngSwitchCase="'Checkbox'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <ul class="check">
                                <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                                  <mat-checkbox
                                    color="primary"
                                    [disabled] = "grpField.rolePermission==1"
                                    [checked]="isChecked(grpField.fieldName, chk)"
                                    (change)="OnChange($event, chk, grpField.fieldID)">
                                    {{ chk }}
                                  </mat-checkbox>
                                </li>
                              </ul>                   
                            </ng-container>
          
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
          
                    <div [ngSwitch]="field.fieldTypeName" class="fullw"  *ngIf="field.fieldID > 0">
          
                      <div *ngSwitchCase="'Textbox'">
                       
                        <ng-container *ngIf="field.fieldNames.length > 0">
                          <ng-container>
                            <div class="multipleBlock">
                              <div class="multype">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select
                                    [ngModel]="field.fieldNameID"
                                    formControlName="{{ field.fieldName + 'option' }}"
                                  >
                                    <mat-option
                                      [value]="names.fieldNameID"
                                      *ngFor="
                                        let names of field.fieldNames;
                                        trackby: fieldNameID
                                      "
                                      >{{ names.fieldName }}</mat-option
                                    >
                                  </mat-select>
                                </mat-form-field>
          
                                <mat-form-field>
                                  <input [required]='field.isRequired'
                                  *ngIf="field.fieldName == 'Phone'"
                                  matInput
                                  placeholder="Add Phone"
                                  [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}"
                                  mask="(000) 000-0000"
                                  [readonly] = "field.rolePermission==1"
                                />
                                <input [required]='field.isRequired'
                                  *ngIf="field.fieldName == 'Email'"
                                  matInput
                                  placeholder="Add Email"
                                  [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}"
                                  [readonly] = "field.rolePermission==1"
                                />
                                <input [required]='field.isRequired'
                                  *ngIf="field.fieldName == 'Address'"
                                  matInput
                                  placeholder="Add Address"
                                  [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}"
                                  [readonly] = "field.rolePermission==1"
                                />
                                </mat-form-field>
          
                                <!-- <mat-form-field>
                                  <input [required]='field.isRequired'
                                  *ngIf="field.fieldName == 'Phone'"
                                  matInput
                                  placeholder="Add Phone"
                                  [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}"
                                  mask="(000) 000-0000"
                                  [readonly] = "field.rolePermission==1"
                                />
                                <input [required]='field.isRequired'
                                  *ngIf="field.fieldName == 'Email'"
                                  matInput
                                  placeholder="Add Email"
                                  [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}"                        
                                  [readonly] = "field.rolePermission==1"
                                  pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                                />
                                <input [required]='field.isRequired'
                                  *ngIf="field.fieldName != 'Phone' && field.fieldName != 'Email' "
                                  matInput
                                  placeholder="Add {{field.placeholder}}"
                                  [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}"
                                  [readonly] = "field.rolePermission==1"
                                />
                                </mat-form-field> -->
                                
                                <!-- // -->
                                <div *ngIf="field.fieldName == 'Address'" class="inOline">
          
                                  <div class="divide">
                                    <mat-form-field>
                                      <input type="text"
                                      placeholder="City"
                                      [(ngModel)]="cityValue"
                                      aria-label="Number"
                                      matInput
                                      (input)="searchCity($event.target.value)"
                                      formControlName="City"
                                      [matAutocomplete]="auto"
                                      [readonly] = "field.rolePermission==1">
                               <mat-autocomplete #auto="matAutocomplete">
                                 <mat-option *ngFor="let option of cityOption" [value]="option">
                                   {{option}}
                                 </mat-option>
                               </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
          
                                  <div class="divide">
                                    <mat-form-field>
                                      
                         <mat-select [disabled] = "field.rolePermission==1"  [(ngModel)]="stateValue"  formControlName="State"  placeholder="State">
                          <mat-option>None</mat-option>
                          <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                        </mat-select>
                                    </mat-form-field>
                                  </div>
          
                                  <div class="divide">
                                    <mat-form-field>
                                      <input type="text"
                                             [(ngModel)]="zipValue"
                                  placeholder="Zip Code"
                                  aria-label="Number"
                                  matInput
                                  (input)="searchZip($event.target.value)"
                                  formControlName="ZipCode"
                                  [matAutocomplete]="ZipCode"
                                  [readonly] = "field.rolePermission==1">
                           <mat-autocomplete #ZipCode="matAutocomplete">
                             <mat-option *ngFor="let option of zipOption" [value]="option">
                               {{option}}
                             </mat-option>
                           </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
          
                                  
                       
                                             
                      </div>
                        <!-- <input *ngIf="field.fieldName == 'Address'"
                                class="addinput"
                                placeholder="Add Country"
                                [(ngModel)]="countryValue"
                                formControlName="Country"
                              /> -->
                                <!-- // -->
                                
                              </div>
                              <span
                                  class="addmore"
                                  (click)="addMoreEditField(field.fieldName)"
                                  *ngIf="field.fieldNames.length > 0"
                                >
                                  Add more
                                </span>
                            </div>
                            <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">
                              <div
                                class="multype"
                                *ngFor="let element of dynamicArray; let i = index"
                              >
                                
                                <div class="primaryEmail"  >
                                  
                                  <mat-form-field class="mulDropdown" appearance="">
                                    <mat-select
                                      [ngModel]="element.fieldNameID"
                                      (selectionChange)="clearPlaceholder($event)"
                                      formControlName="{{ element.fieldName + 'option' }}"
                                      placeholder="{{ element.placeholderVal }}"
                                    >
                                      <mat-option
                                        value="{{ names.fieldNameID }}"
                                        *ngFor="
                                          let names of element.fieldNames;
                                          trackby: fieldNameID
                                        "
                                        >{{ names.fieldName }}</mat-option
                                      >
                                    </mat-select>
                                  </mat-form-field>
          
                                  <!-- <div class="setPrimary"  matTooltip="Set as primary email" matTooltipClass="tooltip"> Primary</div> -->
          
                                </div>
          
                                <mat-form-field>
                                  <input
                                  matInput
                                  placeholder="Add Email"
                                  [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName }}"
                                  [readonly] = "field.rolePermission==1"
                                  pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                                />
                                </mat-form-field>
                                
                              </div>
                              <span
                                  class="addmore"
                                  (click)="addMoreEditField(field.fieldName)"
                                  *ngIf="field.fieldNames.length > 0"
                                >
                                  Add more
                                </span>
                            </div>
          
                            <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                              <div
                                class="multype"
                                *ngFor="let element of dynamicArrayPhone; let i = index"
                              >
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select
                                    [ngModel]="element.fieldNameID"
                                    (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{ element.fieldName + 'option' }}"
                                    placeholder="{{ element.placeholderVal }}"
                                  >
                                    <mat-option
                                      value="{{ names.fieldNameID }}"
                                      *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      "
                                      >{{ names.fieldName }}</mat-option
                                    >
                                  </mat-select>
                                </mat-form-field>
          
                                <mat-form-field>
                                  <input
                                  matInput
                                  
                                  placeholder="Add Phone"
                                  [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName }}"
                                  mask="(000) 000-0000"
                                  [readonly] = "field.rolePermission==1"
                                />
                                </mat-form-field>
          
                                
                                
                              </div>
                              <span
                                  class="addmore"
                                  (click)="addMoreEditField(field.fieldName)"
                                  *ngIf="field.fieldNames.length > 0"
                                >
                                  Add more
                                </span>
                            </div>
          
                            <div class="multipleBlock" *ngIf="field.fieldName == 'Address'"
                            >
                              <div
                                class="multype"
                                *ngFor="let element of dynamicArrayAddress; let i = index"
                              >
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select
                                    [ngModel]="element.fieldNameID"
                                    (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{ element.fieldName + 'option' }}"
                                    placeholder="{{ element.placeholderVal }}"
                                  >
                                    <mat-option
                                      value="{{ names.fieldNameID }}"
                                      *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      "
                                      >{{ names.fieldName }}</mat-option
                                    >
                                  </mat-select>
                                </mat-form-field>
          
                                <mat-form-field>
                                  <input
                                  matInput
                                  placeholder="Add Address"
                                  [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName }}"
                                  [readonly] = "field.rolePermission==1"
                                />
                                </mat-form-field>
                                
                                <div *ngIf="element.address.length>0" class="inOline">
                                  <ng-container  *ngFor=" let adr of element.address;"  >
          
          
                                    <!-- <div class="divide">
                                      <mat-form-field> -->
                                        <input *ngIf="adr.childFieldType==3"
                                        placeholder="City"
                                        [ngModel]="adr.fieldValue"
                                              aria-label="Number"
                                              matInput
                                              (input)="searchCity($event.target.value)"
                                              formControlName="City{{(i + 1) }}"
                                              [matAutocomplete]="auto"
                                              [readonly] = "field.rolePermission==1">
                                       <mat-autocomplete #auto="matAutocomplete">
                                         <mat-option *ngFor="let option of cityOption" [value]="option">
                                           {{option}}
                                         </mat-option>
                                       </mat-autocomplete>
                                      <!-- </mat-form-field>
                                    </div> -->
          
                                    <!-- <div class="divide">
                                      <mat-form-field> -->
                                        <mat-select [disabled] = "field.rolePermission==1" [ngModel]="adr.fieldValue" *ngIf="adr.childFieldType==2" 
                                        formControlName="State{{ (i + 1) }}"  placeholder="State">
                                          <mat-option>None</mat-option>
                                          <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                        </mat-select>
                                      <!-- </mat-form-field>
                                    </div> -->
          
                                    <!-- <div class="divide">
                                      <mat-form-field> -->
                                        <input  *ngIf="adr.childFieldType==4"
                            placeholder="Zip Code"
                            [ngModel]="adr.fieldValue"
                            aria-label="Number"
                            matInput
                            (input)="searchZip($event.target.value)"
                            formControlName="ZipCode{{ (i + 1) }}"
                            [matAutocomplete]="ZipCode"
                            [readonly] = "field.rolePermission==1">
                     <mat-autocomplete #ZipCode="matAutocomplete">
                       <mat-option *ngFor="let option of zipOption" [value]="option">
                         {{option}}
                       </mat-option>
                     </mat-autocomplete>
                                      <!-- </mat-form-field>
                                    </div> -->
           
                  
                          </ng-container>
                             
                            </div>
                              <div *ngIf="element.address.length==0" class="inOline">
          
                                
          
                                <div class="divide">
                                  <mat-form-field>
                                    <input 
                                placeholder="City"
                                aria-label="Number"
                                matInput
                                (input)="searchCity($event.target.value)"
                                formControlName="City{{(i + 1) }}"
                                [matAutocomplete]="auto"
                                [readonly] = "field.rolePermission==1">
                         <mat-autocomplete #auto="matAutocomplete">
                           <mat-option *ngFor="let option of cityOption" [value]="option">
                             {{option}}
                           </mat-option>
                         </mat-autocomplete>
                                  </mat-form-field>
                                </div>
          
          
                                <div class="divide">
                                  <mat-form-field>
                                    <mat-select  [disabled] = "field.rolePermission==1" formControlName="State{{ (i + 1) }}"  placeholder="State">
                                      <mat-option>None</mat-option>
                                      <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
          
          
                                <div class="divide">
                                  <mat-form-field>
                                    <input 
                            placeholder="Zip Code"
                            aria-label="Number"
                            matInput
                            (input)="searchZip($event.target.value)"
                            formControlName="ZipCode{{ (i + 1) }}"
                            [matAutocomplete]="ZipCode"
                            [readonly] = "field.rolePermission==1">
                     <mat-autocomplete #ZipCode="matAutocomplete">
                       <mat-option *ngFor="let option of zipOption" [value]="option">
                         {{option}}
                       </mat-option>
                     </mat-autocomplete>
                                  </mat-form-field>
                                </div>
          
                                
                             
                            
                              </div>
                             
                                
                              </div>
                              <span
                                  class="addmore"
                                  (click)="addMoreEditField(field.fieldName)"
                                  *ngIf="field.fieldNames.length > 0"
                                >
                                  Add more
                                </span>
                            </div>
          
                            <div
                              class="multipleBlock"
                              *ngIf="field.fieldName == 'WebSite'"
                            >
                              <div
                                class="multype"
                                *ngFor="let element of dynamicArrayWebsite; let i = index"
                              >
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select
                                    [ngModel]="element.fieldNameID"
                                    (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{
                                      element.fieldName + 'option'
                                    }}"
                                    placeholder="{{ element.placeholderVal }}"
                                  >
                                    <mat-option
                                      value="{{ names.fieldNameID }}"
                                      *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      "
                                      >{{ names.fieldName }}</mat-option
                                    >
                                  </mat-select>
                                </mat-form-field>
          
                                <mat-form-field>
                                  <input
                                  matInput
                                  placeholder="WebSite"
                                  [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName + (i + 1) }}"
                                  [readonly] = "field.rolePermission==1"
                                />
                                </mat-form-field>
          
                               
                                
                              </div>
                              <span
                                  class="addmore"
                                  (click)="addMoreEditField(field.fieldName)"
                                  *ngIf="field.fieldNames.length > 0"
                                >
                                  Add more
                                </span>
                            </div>
                          </ng-container>
                        </ng-container>
          
                        <mat-form-field *ngIf="field.fieldName == 'Name'">
                          <input
                            matInput
                            matTooltip="Readonly Field"
                            [required]="field.isRequired"
                            [(ngModel)]="addByName"
                            placeholder="{{ field.fieldName }}"
                            formControlName="{{ field.fieldName }}"
                           
                          />
                          <mat-error
                            *ngIf="
                              myFormGroup.get(field.fieldName).invalid &&
                              (myFormGroup.get(field.fieldName).dirty ||
                                myFormGroup.get(field.fieldName).touched)
                            "
                          >
                            <span *ngIf="myFormGroup.get(field.fieldName).errors.required"
                              >This field is mandatory.</span
                            > 
                          </mat-error>
                        </mat-form-field>
          
                        <mat-form-field
                          *ngIf="
                            field.fieldNames.length === 0 && field.fieldName != 'Name'
                          "
                        >
          
                        <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired'
                            matInput
                            [(ngModel)]="field.fieldValue"
                            placeholder="{{ field.fieldName }}"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"
                          />
                        </mat-form-field>
          
                      </div>
          
                      <div *ngSwitchCase="'Textarea'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <textarea [required]='field.isRequired'
                            matInput
                            [(ngModel)]="field.fieldValue"
                            placeholder="{{ field.fieldName }}"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"
                            ></textarea>
                        </mat-form-field>
                      </div>
          
                      <div *ngSwitchCase="'Number'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired'
                            matInput
                            (keypress)="numberOnly($event)"
                            placeholder="{{ field.fieldName }}"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"/>
                        </mat-form-field>
                      </div>
          
                      <div *ngSwitchCase="'Currency'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired'
                            matInput                
                            placeholder="{{ field.fieldName }}"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"/>
                        </mat-form-field>
                      </div>
          
                      <div *ngSwitchCase="'Address'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired'
                            matInput                
                            placeholder="{{ field.fieldName }}"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"/>
                        </mat-form-field>
                      </div>
          
                      <div *ngSwitchCase="'URL'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired'
                            matInput
                            [(ngModel)]="field.fieldValue"
                            placeholder="{{ field.fieldName }}"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"
                          />
                        </mat-form-field>
                      </div>
          
                      <div *ngSwitchCase="'Date'">
                        <mat-form-field>
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <input [required]='field.isRequired'
                            matInput
                            [matDatepicker]="basicDatepicker"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"
                          />
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="basicDatepicker"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #basicDatepicker></mat-datepicker>
                        </mat-form-field>
                      </div>
          
                    
          
                      <ng-container *ngSwitchCase="'Dropdown'">
                        <mat-form-field *ngIf="field.fieldName == 'Type'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-select [required]='field.isRequired' [(ngModel)]="TypeIdDrp"  formControlName="{{ field.fieldName }}"
                          (selectionChange)="getCoreUserDetailsOnTypeChange($event,field.fieldName)">
                            <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                              {{typelist.folderName}}
                            </mat-option>
                          </mat-select>
                         
                        </mat-form-field>
          
                        <mat-form-field *ngIf="field.fieldName != 'Type'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-select [required]='field.isRequired' [ngModel]="getddlSelectedVal(field.fieldName)" 
                          formControlName="{{ field.fieldName }}" 
                          [disabled] = "field.rolePermission==1">
                            <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                              {{ drp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
          
                      
                      <ng-container *ngSwitchCase="'MultiSelect'">
          
                        <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
                            <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                              (removed)="remove(tag)">
                              {{tag}}
                              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                              (matChipInputTokenEnd)="add($event)">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                            <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                              {{tag}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
          
                        <mat-form-field *ngIf="field.fieldName != 'Tags'">
                          <mat-label>{{ field.fieldName }}</mat-label>
                          <mat-select [required]='field.isRequired' multiple [ngModel]="getMultiddlSelectedVal(field.fieldName)"
                            formControlName="{{ field.fieldName }}" [disabled] = "field.rolePermission==1">
                            <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                              {{ muldrp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
          
                     
                      <ng-container *ngSwitchCase="'Checkbox'">
                        <div class="checkList">
                          <mat-label>{{ field.fieldName }}</mat-label>
          
                          <div class="allCheckList"  *ngFor="let chk of getCheckBoxlist(field.fieldName)" >
                            <mat-checkbox
                              color="primary"
                              [disabled] = "field.rolePermission==1"
                              [checked]="isChecked(field.fieldName, chk)"
                              (change)="OnChange($event, chk, field.fieldID)">
                              {{ chk }}
                            </mat-checkbox>
                          </div>
                        </div>
                      </ng-container>
          
                    </div>
                  </ng-container>
          
                 
                </form>
              </div>
          </div>
        </mat-tab>
      </mat-tab-group>

      

    </div>

    <div class="actionBtn" *ngIf="tabType==0">
      <button mat-flat-button class="cancel" (click)="closedetail(close)">Cancel</button>
      <button *ngIf="SingleTaskArchived==false" mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="myTaskForm.dirty==false && showTaskUpdateButton==false "
        (click)="updateTaskDetail(myTaskForm.value)">
        Save Task Detail
        <mat-icon *ngIf="spinner">
          <mat-spinner diameter="20">
          </mat-spinner>
        </mat-icon>
      </button>

      <button *ngIf="SingleTaskArchived==true" mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="true"
        (click)="updateTaskDetail(myTaskForm.value)">
        Save Task Detail
       
      </button>

    </div>
    <div class="actionBtn" *ngIf="IsCustomFieldExist && tabType==1">
      <button mat-stroked-button class="cancel" (click)="closedetail(close)">Cancel</button>
      <button
        mat-flat-button class="calltoaction"  [disabled]="myFormGroup.invalid || !myFormGroup.dirty" type="submit"
        (click)="SaveCoreUserDetails(myFormGroup.value)" color="primary">
        Update Fields
      </button>
    </div>
    <div class="actionBtn" *ngIf="!IsCustomFieldExist && tabType==1">
      <button mat-flat-button class="cancel" (click)="closedetail(close)">
        Cancel
      </button>
      <button mat-flat-button class="calltoaction" 
        [disabled]="myFormGroup.invalid || !myFormGroup.dirty" type="submit"
        (click)="onSubmit(myFormGroup.value, myFormGroup)" color="primary">
        Save Fields
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
    </div>
  </form>
</mat-card>


<div class="documentOverlay" (click)="closedetail(close)"></div>



<ng-template #addFolderDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>description</mat-icon>
    </span>
    Attach Task Template
    <button mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="statusArea">
      <div class="head">
        <select>
          <option value="" disabled selected>Select task status</option>
          <option>Waiting</option>
          <option>In Progress</option>
          <option>Decline</option>
        </select>
        <div class="search">
          <input type="text" placeholder="Search template">
        </div>

        <button mat-icon-button color="primary"
          style="margin-left: 10px; width: 25px; height: 25px; line-height: 25px; ">
          <mat-icon>add_circle</mat-icon>
        </button>

      </div>
      <div class="taskList">
        <ul>
          <li>
            <span class="triggerStatus">Waiting</span>
            <div class="taskList">
              Finger Surgery <span class="badge" (click)="addtasks(addTasks)">18</span>
              <mat-icon>delete</mat-icon>
            </div>
            <div class="taskList">
              On Boarding User <span class="badge">15</span>
              <mat-icon>delete</mat-icon>
            </div>
          </li>

          <li>
            <span class="triggerStatus">In Progress</span>
            <div class="taskList">
              Reports Validations <span class="badge">15</span>
              <mat-icon>delete</mat-icon>
            </div>
          </li>
          <li>
            <span class="triggerStatus">Declined</span>
            <div class="taskList">
              Patient Reports Verifications <span class="badge">15</span>
              <mat-icon>delete</mat-icon>
            </div>
          </li>
        </ul>
      </div>
    </div>



  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-flat-button color="basic"> Cancel</button>
    <button mat-flat-button color="primary">
      Attach
    </button>
  </mat-dialog-actions>
</ng-template>




<ng-template #addTasks>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>description</mat-icon>
    </span>
    Finger Surgery
    <button mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="statusArea">

      <div class="taskList">
        <ul>
          <li>Finger Surgery <mat-icon>delete</mat-icon>
          </li>
          <li>On Boarding User <mat-icon>delete</mat-icon>
          </li>
          <li>Patient Reports Verifications <mat-icon>delete</mat-icon>
          </li>
          <li>Finger Surgery <mat-icon>delete</mat-icon>
          </li>
          <li>On Boarding User <mat-icon>delete</mat-icon>
          </li>
          <li>Patient Reports Verifications <mat-icon>delete</mat-icon>
          </li>
          <li>Finger Surgery <mat-icon>delete</mat-icon>
          </li>
          <li>On Boarding User <mat-icon>delete</mat-icon>
          </li>
          <li>Patient Reports Verifications <mat-icon>delete</mat-icon>
          </li>
          <li>Finger Surgery <mat-icon>delete</mat-icon>
          </li>
          <li>On Boarding User <mat-icon>delete</mat-icon>
          </li>
          <li>Patient Reports Verifications <mat-icon>delete</mat-icon>
          </li>
        </ul>
      </div>
    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-flat-button color="basic"> Cancel</button>
   
  </mat-dialog-actions>
</ng-template>